export default {
  common: {
    confirm: '확인',
    cancel: '취소',
    none: '없음',
    weekdayShort: {
      sun: '일',
      mon: '월',
      tue: '화',
      wed: '수',
      thu: '목',
      fri: '금',
      sat: '토'
    },
    logout: '로그아웃',
    messages: '메시지',
    download: '다운로드',
    downloadStatus: {
      downloading: '파일 다운로드 중',
      complete: '다운로드 완료'
    },
    print: '프린트',
    year: '년도',
    pdf: 'PDF',
    excel: 'Excel',
    noData: '데이터가 없습니다',
    noDataFound: '조회된 데이터가 없습니다',
    searchGuide: '검색하여 데이터를 확인하세요',
    listLoadCount: '로드 {{loaded}} / 전체 {{total}}건',
    endOfList: '목록의 끝입니다',
    january: '1월',
    february: '2월',
    march: '3월',
    april: '4월',
    may: '5월',
    june: '6월',
    july: '7월',
    august: '8월',
    september: '9월',
    october: '10월',
    november: '11월',
    december: '12월',

    searching: '검색 중...',
    enterSearchTerm: '검색어를 입력해주세요.',
    currentTime: '현재 시간',
    wait: '잠시만 기다려주세요...',
    noData: '데이터가 없습니다.',
    comingSoon: '준비중',
    logoutConfirmTitle: '로그아웃',
    logoutConfirmMessage: '로그아웃 하시겠습니까?',
    save: '저장',
    delete: '삭제',
    deleteSuccess: '삭제되었습니다.',
    edit: '수정',
    modify: '수정',
    reset: '초기화',
    actions: '작업',
    action: '작업',
    rowsPerPage: '페이지당 행 수:',
    of: '중',
    allStatus: '모든 상태',
    allTypes: '모든 유형',
    add: '새로 추가',
    status: '상태',
    close: '닫기',
    more: '더보기',
    saving: '저장 중...',
    updating: '업데이트 중...',
    retry: '다시 시도',
    deleting: '삭제 중...',
    success: '성공',
    remark: '비고',
    language: '언어',
    clearAllFilters: '모두 지우기',
    hideFilters: '필터 숨기기',
    showFilters: '필터 보기',
    warning: '경고',
    information: '정보',
    forbidden: '접근 거부됨',
    notFound: '리소스를 찾을 수 없음',
    badRequest: '잘못된 요청',
    loading: '로딩 중...',
    processing: '처리중...',
    checkingAuthentication: '인증 확인 중...',
    verify: '확인',
    preparing: '준비중',
    loggingOut: '로그아웃 중...',
    startDate: '시작 날짜',
    endDate: '종료 날짜',
    excel: 'Excel',
    columnSelection: '컬럼 선택',
    columnSettings: '컬럼 설정',
    selectAll: '모두 선택',
    unselectAll: '모두 선택 해제',
    totalItems: '총 항목',
    items: '개',
    selectedItems: '선택된 항목',
    itemsSelected: '{{count}}개 항목 선택됨',
    noItemsSelected: '선택된 항목 없음',
    batchSettings: '일괄 설정',
    apply: '적용',
    applied: '완료',
    totalQty: '총 수량',
    remainingQty: '잔여 수량',
    workQty: '작업 수량',
    split: '분할',
    existing: '기존',
    processing: '처리 중...',
    saving: '저장 중...',
    dateFormat: {
      full: 'YYYY년 MM월 DD일',
      short: 'YYYY-MM-DD',
      month: 'MM월'
    },
    selectDateRange: '날짜 범위 선택',
    customRange: '사용자 지정',
    dateRanges: {
      today: '오늘',
      yesterday: '어제',
      thisWeek: '이번 주',
      lastWeek: '지난 주',
      thisMonth: '이번 달',
      lastMonth: '지난 달',
      last7Days: '최근 7일',
      last30Days: '최근 30일',
      last90Days: '최근 90일'
    },
    searchType: '검색 유형',
    searchKeyword: '검색어 입력',
    all: '전체',
    unauthorized: '권한 없음',
    noAccessRights: '이 페이지에 접근할 권한이 없습니다',
    error: '오류',
    refresh: '새로고침',
    no: 'No',
    date: '날짜',
    complete: '완료',
    register: '등록',
    print: '프린트',
    printPreview: '프린트 미리보기',
    start: '시작',
    saveAndClose: '저장 후 닫기',
    statusCode: '상태 코드',
    underConstruction: '개발중',
    searchConditions: '검색 조건',
    search: '검색',
    searching: '검색 중...',
    currentTime: '현재 시간',
    noResults: '검색 결과가 없습니다',
    additionalFilters: '추가 필터',
    searchFields: {
      styleNo: '스타일 번호',
      item: '품목',
      color: '컬러명',
      customer: '고객사',
      buyer: '바이어',
      dyeingNo: '염색 번호',
      productionNo: '생산 번호',
      orderNo: '오더 번호',
      fileNo: '파일 번호',
      factory: '입고처',
      name: '담당자',
      size: '사이즈',
      quantity: '수량',
      status: '상태',
      search: '검색'
    },
    list: {
      title: '목록'
    },
    select: '선택',
    columns: {
      no: 'No',
      id: 'ID',
      date: 'DATE',
      requestAt: 'REQ@',
      recipeAt: 'RECIPE@',
      orderNo: '오더 번호',
      size: 'SIZE',
      color: 'COLOR',
      qty: 'QTY',
      cheese: 'CHEESE',
      workType: '작업 종류',
      misc: 'REMARK',
      confirmType: '컨펌 여부',
      stockType: '스톡 여부',
      urgent: 'URGENT',
      workProcess: '작업 프로세스',
      sample: 'SAMPLE',
      workStartDate: 'START DATE',
      dyeingNo: 'DYEING NO',
      recipeId: 'RECIPE ID',
      windingNo: 'WINDING NO',
      targetDate: 'TARGET',
      planDate: 'PLAN DATE',
      delivery: 'DELIVERY',
      line: 'LINE',
      rackCode: 'RACK CODE',
      factory: 'FACTORY',
      item: 'ITEM',
      styleNo: 'STYLE NO',
      style: 'STYLE',
      remark: 'REMARK',
      operation: 'OPERATION',
      productionNo: 'PRODUCTION NO',
      workChees: 'WORK CHEES',
      recipe: 'RECIPE',
      mc: 'M/C',
      workStatus: 'STATUS',
      lot: 'LOT',
      factory: 'FACTORY',
      vendor: 'VENDOR',
      customer: 'CUSTOMER'
    },
    creating: '생성 중...',
    modifying: '수정 중...',
    yes: 'Yes',
    no: 'No'
  },

  menu: {
    notices: '공지사항',
    orderManagement: '오더 관리',
    orderInput: '오더 입력',
    orderModify: '오더 수정',
    workOrder: '오더 현황',
    orderSearch: '오더 검색',
    swatchManagement: '샘플 발송 & 컨펌',
    invoiceIssuance: '인보이스 발급',
    invoiceManagement: '인보이스 관리',
    paymentManagement: '매출 관리',
    dyeingManagement: '염색 관리',
    dyeingWork: '염색 요청',
    dyeingOperation: '염색 작업',
    dyeingStatus: '염색 현황',
    recipeSearch: '레시피 검색',
    windingManagement: '와인딩 관리',
    windingRequest: '와인딩 요청',
    windingOperation: '와인딩 작업',
    windingStatus: '와인딩 현황',
    shippingDelivery: '출고 관리',
    shippingRequest: '출고 요청',
    shippingOperation: '출고 작업',
    shippingTracking: '출고 추적',
    workRequest: '작업 요청',
    financeManagement: '재무 관리',
    financeOverview: '재무 현황',
    inventoryManagement: '재고 관리',
    inventory: {
      balance: '재고 잔고 조회',
      lotBatch: 'LOT 관리',
      transactionHistory: '재고 변동 조회',
      transfer: '재고 이동',
      adjustment: '재고 이동',
      batchInput: '일괄 입력'
    },
    scmManagement: '공급망 관리',
    scm: {
      goodsReceipt: '입고 등록',
      goodsIssueList: '출고 현황',
      goodsIssueRegistration: '출고 등록',
      deliveryInfo: '배송 등록',
      deliveryStatus: '배송 현황'
    },
    masterData: '주 데이터',
    masterDataMenu: {
      item: '품목',
      uomConversion: 'UOM & 환산',
      location: '창고 위치',
      supplier: '공급자 등록',
      itemTaxon: '품목 분류',
      customer: '거래처',
      buyer: '바이어'
    },
    expand: "메뉴 펼치기",
    collapse: "메뉴 접기",
    admin: {
      title: '관리자',
      userManagement: {
        title: '사용자 관리',
        registration: '회원가입 관리',
        resetPassword: '비밀번호 재설정',
        accessLogs: '접속 로그 확인',
        sendMessage: '메시지 보내기'
      },
      standardsManagement: {
        title: '기준정보 관리',
        threads: '아이템 관리',
        companies: '거래처 관리',
        buyers: '바이어 관리',
        prices: '단가 관리',
        sizes: '길이(M) 관리',
        machine: '기계 관리'
      },
      materialsManagement: {
        title: '자재 관리',
        yarn: '원사 관리',
        dye: '염료 관리',
        inventory: '재고 관리'
      },
      bi: {
        title: 'BI',
        startDate: '시작일',
        endDate: '종료일',
        manager: '담당자',
        search: '검색',
        orderDate: '오더 등록일',
        vendorName: '업체명',
        itemName: '아이템',
        size: '사이즈',
        color: '컬러',
        qty: '수량',
        price: '단가',
        amount: '금액',
        grandTotal: '총합계',
        noData: '데이터가 없습니다',
        title: 'BI'
      }
    }
  },
  giRequest: {
    shippingMarkNote: {
      title: '쉬핑마크 문구',
      placeholder: '쉬핑마크에 표시할 문구를 입력하세요',
      download: '다운로드',
      instruction: '스타일을 드래그해서 그룹을 나누세요. 문구를 비워두면 CITY가 표시됩니다.',
      group: '{{n}}번 그룹',
      addGroup: '그룹 추가',
      removeGroup: '그룹 삭제',
      styleCount: '스타일 {{count}}개',
      emptyGroup: '스타일을 이 그룹으로 옮기세요',
      autoGroupByRemark: 'REMARK 자동 구분',
      columns: {
        style: 'STYLE',
        fileNo: 'FILE NO',
        item: 'ITEM',
        size: 'SIZE',
        dyeingNo: 'DYEING NO',
        color: 'COLOR',
        qty: 'QTY',
        remark: 'REMARK'
      }
    },
    tabs: {
      general: '일반 출고',
      batch: '일괄 요청',
      bulkList: 'GI 그룹 목록',
      dailyCalendar: '일별 달력',
      requestStatus: '요청 현황'
    },
    row: {
      requested: '요청완료',
      partial: '일부요청',
      fullyRequestedHint: '전 수량 GI 요청 완료\n추가 요청 불가'
    },
    qtyErrors: {
      title: '출고 요청을 발급할 수 없습니다',
      empty: '출고 수량이 비어있습니다.',
      invalid: '출고 수량이 올바른 숫자가 아닙니다.',
      negative: '출고 수량은 0 이상이어야 합니다.',
      zero: '출고 수량은 0보다 커야 합니다.',
      decimal: '출고 수량은 소수점 2째자리까지만 입력 가능합니다.',
      exceed: '출고 수량이 오더 수량을 초과하였습니다.',
      generalSummary: '수량이 주문 수량을 초과합니다.',
      generalLineRemain: '서브오더 {{subId}}: 입력 {{qty}} > 잔여 {{remain}} (주문 {{order}}, 이미 요청 {{requested}})',
      generalLineOrder: '서브오더 {{subId}}: 입력 {{qty}} > 주문 수량 {{order}}'
    },
    bulkList: {
      fromDate: '시작 날짜',
      toDate: '종료 날짜',
      giNo: 'GI 번호',
      delivery: 'DELIVERY',
      plannedDate: '계획 출고일',
      lineCount: '라인 수',
      lineCountChip: '{{count}}개',
      summary: '요약',
      subOrder: '서브오더',
      styleNo: '스타일',
      vendor: '거래처',
      dyeingNo: '염색번호',
      color: '컬러',
      item: '아이템',
      qty: '수량',
      downloadPackingList: '패킹리스트 다운로드',
      downloadPackingListExim: '패킹리스트 (EXIM)',
      downloadPackingListAccount: '패킹리스트 (ACCOUNTING)',
      downloadShippingMark: 'Shipping Mark',
      searchPrompt: '검색 버튼을 눌러 데이터를 조회하세요.',
      dateRequired: '시작/종료 날짜를 입력해주세요.',
      invalidDateRange: '시작 날짜가 종료 날짜보다 늦을 수 없습니다.',
      noLineToDownload: '다운로드할 라인이 없습니다.',
      deleteGi: 'GI 그룹 삭제',
      deleteTitle: 'GI 그룹 삭제',
      deleteConfirm: '{{giNo}} ({{count}}개 라인)을 삭제합니다. 이 작업은 되돌릴 수 없습니다.',
      deleteAskShort: '{{giNo}} 을 삭제하시겠습니까?',
      deleteBlockedTitle: 'GI 그룹 삭제 불가',
      deleteBlockedMessage: '{{giNo}} 을(를) 삭제할 수 없습니다.',
      deleteBlockedHeading: '경고',
      deleteBlockedBody: '현재 연결 된 인보이스가 있습니다. 인보이스 발행 후엔 GI 그룹을 삭제할 수 없습니다.',
      deleteBlockedBody1: '현재 연결 된 인보이스가 있습니다.',
      deleteBlockedBody2: '인보이스 발행 후엔 GI 그룹을 삭제할 수 없습니다.',
      deleteInvoiceWarn: '경고: 이 GI에 연결된 인보이스가 있습니다 ({{nos}}). 삭제 시 인보이스 표시 정합성이 영향받을 수 있습니다.',
      deleteSuccess: 'GI 그룹이 삭제되었습니다.',
      deleteFailed: 'GI 그룹 삭제에 실패했습니다.',
      deleteLine: '출고 삭제',
      lineDeleteTitle: '출고 삭제',
      lineDeleteAsk: '{{giNo}} 의 서브오더 {{subOrder}} 출고를 삭제하시겠습니까?',
      lineDeleteSuccess: '출고가 삭제되었습니다.',
      lineDeleteFailed: '출고 삭제에 실패했습니다.',
      dailyTotalsHeading: '일별 출고 요청 합계'
    },
    box: {
      tabSubOrder: '서브오더 집계',
      tabBox: '박스',
      boxNo: '박스 번호',
      originalNo: '원래 번호',
      finalNo: '최종 번호',
      status: '상태',
      merged: '통합',
      summary: '물리 박스 {{boxes}}개 (행 {{rows}}개)',
      countChip: '박스 {{count}}',
      customBadge: '번호 편집됨',
      none: '이 출고 요청에는 박스 번호가 없습니다.',
      generate: '박스 번호 생성',
      edit: '번호 편집',
      editTitle: '박스 번호 편집',
      save: '저장',
      regenerate: '다시 만들기',
      regenerateTitle: '박스 다시 만들기',
      regenerateConfirm: '번호 편집 내용이 모두 사라집니다. 계속할까요?',
      previewHint: '저장하면 번호가 1부터 다시 매겨집니다. 최종 번호 열에서 결과를 확인하세요.',
      loadFailed: '박스 정보를 불러오지 못했습니다.',
      saveFailed: '박스 번호 저장에 실패했습니다.',
      generateFailed: '박스 번호 생성에 실패했습니다.',
      conflict: '다른 사용자가 먼저 변경했습니다. 다시 불러옵니다.',
      lineDeleteRenumberWarn: '박스 번호가 1부터 다시 매겨집니다.',
      applyStyleOrder: '박스 번호 정리',
      multiGiPackingNotice: '여러 출고 요청이 포함되어 CT 번호가 이어붙여집니다.'
    },
    mergePicker: {
      title: '병합 대상 선택',
      description: '같은 납품처/계획일자에 기존 출고 요청이 여러 개 있습니다.\n어느 출고 요청에 라인을 추가할지 선택하거나, 새로 생성할 수 있습니다.',
      currentDelivery: '현재 납품처',
      currentItemsHeading: '추가하려는 출고 라인',
      conflictNotice: '⚠ 추가하려는 출고가 이미 다른 출고 요청에 존재합니다.\n중복을 피하기 위해 해당 출고 요청에만 병합할 수 있으며, 다른 출고 요청 또는 새 생성을 원하시면 기존 출고를 삭제(🗑)하세요.',
      markDelete: '이 출고를 삭제 (확인 시 실제 반영)',
      cancelDelete: '삭제 취소',
      plannedDate: '계획일',
      lineCount: '출고 수',
      createNew: '새 출고 요청으로 생성',
      summaryTitle: '선택된 출고 요청 상세',
      linesHeading: '출고 목록',
      remarks: '비고'
    },
    form: {
      title: '일반 출고 요청 등록',
      editTitle: '일반 출고 요청 수정',
      confirmAddTitle: '출고 요청 등록',
      confirmAddMessage: '입력한 정보로 출고 요청을 생성하시겠습니까?',
      addSuccess: '출고 요청이 성공적으로 등록되었습니다.',
      confirmEditTitle: '출고 요청 수정',
      confirmEditMessage: '변경된 정보를 저장하시겠습니까?',
      editSuccess: '출고 요청이 성공적으로 수정되었습니다.',
      deliveryId: '배송지 ID',
      plannedDispatchAt: '계획 출고일',
      remarks: '비고',
      lines: '라인 상세',
      lineLabel: '{{index}}번째 라인',
      docType: '문서 유형',
      docRefNo: '문서 번호',
      item: '품목',
      qty: '수량',
      lotId: 'LOT',
      locationFrom: '출고 위치',
      rackFrom: '랙 정보',
      separatePacking: '별도 패킹',
      splitShipment: '출고 분리',
      splitShipmentHint: '동일 서브오더를 다른 출고일·수량으로 분리합니다',
      removeSplitGroup: '분리 취소',
      deliveryInfo: '배송지 정보',
      deliveryName: '배송지명',
      deliveryPartnerId: '파트너 ID',
      deliveryPartnerName: '파트너명',
      deliveryPartnerCode: '파트너 코드',
      deliveryShippingMark: '선적 마킹',
      deliveryDistrict: '지역',
      deliveryAddress: '주소',
      deliveryAddress2: '추가 주소',
      deliveryPostcode: '우편번호',
      deliveryCountryCode: '국가 코드',
      deliveryTaxId: '세금 ID',
      deliveryTaxType: '세금 ID 유형',
      deliveryCustomsId: '통관 ID',
      deliveryCustomsType: '통관 ID 유형',
      deliverySpecification: '사양',
      deliveryCreatorRegion: '등록 지역',
      deliveryCreatedAt: '생성일',
      deliveryUpdatedAt: '수정일'
    },
    displayFilter: '표시 필터',
    incomplete: '미완료',
    requestable: '요청 가능',
    createRequest: '출고 요청',
    completedFilterTooltip: '켜면 GI Req. 수량이 있는 행을 숨깁니다.',
    editRequest: '출고 요청 수정',
    updateRequest: '출고 요청 수정',
    editInGeneralTab: '일반 출고탭에서 수정, 삭제를 진행해주세요.',
    request: '출고 요청',
    vendor: '공급업체',
    manager: '담당자',
    unknownItem: '알 수 없는 품목',
    totalRequestsWillBeCreated: '총 {{count}}개의 출고 요청이 생성됩니다.',
    validation: {
      qtyEmpty: '출고 요청 {{requestNumber}}의 "{{itemName}}" 수량이 비어있습니다.',
      qtyInvalid: '출고 요청 {{requestNumber}}의 "{{itemName}}" 수량 "{{qtyValue}}"은(는) 숫자로 변환할 수 없습니다.',
      qtyNegative: '출고 요청 {{requestNumber}}의 "{{itemName}}" 수량은 0 이상이어야 합니다.',
      qtyDecimalPlaces: '출고 요청 {{requestNumber}}의 "{{itemName}}" 수량은 소수점 2째자리까지만 입력 가능합니다.',
      qtyInputError: '수량 입력 오류가 발생했습니다.'
    },
    errors: {
      createFailed: '출고 요청 생성에 실패했습니다.',
      createError: '출고 요청 생성 중 오류가 발생했습니다.',
      partialCreateFailed: '일부 출고 요청 생성에 실패했습니다.',
      errorDetail: '- 공급업체 ID: {{vendorId}}, 납품처 ID: {{deliveryId}}\n  오류: {{error}}'
    },
    list: {
      title: '출고 요청 목록',
      id: '요청 ID',
      plannedDispatchAt: '계획 출고일',
      plannedFrom: '계획 시작일',
      plannedTo: '계획 종료일',
      delivery: '배송지',
      remarks: '비고',
      approval: '승인 상태',
      lines: '요청 상세',
      searchPlaceholder: '출고 요청 ID, 배송지, 비고 검색',
      qtyLabel: '{{qty}} EA',
      approved: '승인 완료',
      pendingApproval: '승인 대기'
    },
    validation: {
      required: '필수 정보를 입력해주세요.',
      lineRequired: '라인 정보에 필요한 값을 입력해주세요.'
    },
    errors: {
      generic: '출고 요청 처리 중 오류가 발생했습니다.'
    },
    packingList: {
      dialogTitle: 'Packing List 다운로드',
      dialogTitleExim: 'Packing List 다운로드 (EXIM)',
      dialogTitleAccount: 'Packing List 다운로드 (ACCOUNTING)',
      dialogTitleShippingMark: 'Shipping Mark 다운로드',
      accountFileSplit: '커스터머 / 담당자 / DELIVERY 별로 분리 다운로드',
      dialogDescription: '가격 변환을 위한 환율 옵션을 선택하세요 (USD → IDR)',
      useOrderRate: '오더 등록 시 환율 사용',
      notSet: '미설정',
      manualInput: '직접 입력 :',
      manualPlaceholder: '예: 15800',
      noConversion: '환율 변환 없음 (USD만 표시)',
      download: '다운로드',
      cancel: '취소',
      downloadFailed: 'Packing List 다운로드에 실패했습니다.',
      buttonTooltip: 'Packing List 엑셀 다운로드'
    }
  },

  orders: {
    title: '오더 기본 정보 입력',
    detailTitle: '오더 상세',
    modifyTitle: '오더 수정',
    tabs: {
      sales: '일반 오더',
      basic: '기본',
      internalProduction: '내부 생산 오더'
    },
    internal: {
      inputTitle: '내부 생산 오더 입력',
      listTitle: '내부 생산 오더 목록',
      vendorFixedHint: '내부 생산 오더는 벤더가 고정됩니다.'
    },
    list: {
      title: '오더 목록',
      searchPlaceholder: '오더 번호, 고객사, 바이어, 스타일 등으로 검색...'
    },
    search: {
      orderNumberLabel: '오더 번호',
      orderNumberPlaceholder: '오더 번호를 입력하세요 (예: 202512260)',
      enterOrderNumber: '오더 번호를 입력해주세요.',
      orderOrStyleLabel: '오더 번호 / 스타일 번호',
      orderOrStylePlaceholder: '오더 번호 또는 스타일 번호 입력 (숫자만: 오더+스타일 검색, 문자 포함: 스타일만 검색)',
      enterOrderOrStyle: '오더 번호 또는 스타일 번호를 입력해주세요.',
      noResults: '검색 결과가 없습니다.',
      resultsFound: '{{count}}개의 결과를 찾았습니다.'
    },
    subOrder: {
      detail: {
        title: '서브오더 상세 정보',
        subOrderId: '서브오더 ID',
        fetchError: '서브오더 정보를 가져오는데 실패했습니다.',
        basicInfo: '기본 정보',
        detailInfo: '상세 정보',
        dyeingRequest: '염색 요청',
        dyeingRequestBefore: '염색 요청 이전',
        swatchInfo: '스와치 정보',
        dyeingProcess: '염색 공정',
        dyeingProcessEvent: '염색 공정 이벤트',
        windingProcess: '와인딩 공정',
        windingProcessEvent: '와인딩 공정 이벤트',
        noProcess: '공정 없음',
        noEvent: '이벤트 없음',
        orderId: '오더 ID',
        buyer: '바이어',
        vendor: '벤더',
        manager: '매니저',
        delivery: '배송지',
        styleNo: '스타일 번호',
        fileNo: '파일 번호',
        orderReceivedDate: '오더 수신일',
        orderCreator: '오더 생성자',
        attachedFiles: '첨부 파일',
        threadName: '스레드명',
        size: '사이즈',
        itemName: '품명',
        color: '컬러',
        quantity: '수량',
        unitPrice: '단가',
        totalAmount: '총 금액',
        currency: '통화',
        createdAt: '생성일',
        rawYarn: '원사',
        dyeingNo: '염색 번호',
        dyeingRequestType: '염색 요청 타입',
        requestCheeseNum: '요청 치즈 수',
        repeat: 'Repeat',
        urgent: 'URGENT',
        confirm: '컨펌',
        requester: '요청자',
        requestDate: '요청일',
        remark: '비고',
        swatchQty: '스와치 수량',
        swatchSize: '스와치 사이즈',
        swatchRemark: '스와치 비고',
        productionId: '생산 ID',
        recipeId: '레시피 ID',
        cheeseNum: '치즈 수',
        machineNo: '기계 번호',
        status: '상태',
        dyeingStart: '염색 시작',
        dyeingEnd: '염색 종료',
        storage: '보관',
        lastUpdate: '최근 업데이트',
        eventName: '이벤트명',
        author: '작성자',
        value1: '값1',
        value2: '값2',
        windingId: '와인딩 ID',
        requestQty: '요청 수량',
        productionQty: '생산 수량',
        deliveryQty: '출고 수량',
        targetDate: '목표일',
        plannedDate: '계획일',
        dryingRequired: '건조 필요',
        departureTime: '출발 시간',
        arrivalTime: '도착 시간',
        giRequest: '출고 요청',
        giRequestId: '출고 요청 ID',
        plannedDispatchAt: '예정 출고일',
        giRequestLines: '출고 요청 라인 정보',
        lineNo: '라인 번호',
        docType: '문서 유형',
        docRefNo: '참조 번호',
        qty: '수량',
        lotId: 'LOT ID',
        locationFrom: '출고 위치',
        rackFrom: '랙',
        giRequestBefore: '출고 요청 정보가 없습니다.',
        giLot: '출고 LOT',
        lotNo: 'LOT 번호',
        expectedGiAt: '예정 출고일',
        workShift: '작업 교대',
        docId: '문서 ID',
        address: '주소',
        attributes: '속성',
        qtyBox: '박스 수',
        mfgDate: '제조일',
        expiryDate: '유통기한',
        qcStatus: 'QC 상태',
        giLotBefore: '출고 LOT 정보가 없습니다.',
        giPost: '출고 등록',
        giPostId: '출고 등록 ID',
        giPostNo: '출고 문서번호',
        outboundLotNo: '출고 LOT 번호',
        giTime: '출고 시각',
        customsDocNo: '세관 문서 번호',
        createdBy: '생성자',
        giPostBefore: '출고 등록 정보가 없습니다.'
      }
    },
    addItem: '항목 추가',
    fields: {
      orderNo: '번호',
      customer: '고객사',
      factory: '입고처',
      contact: '담당자',
      buyer: '바이어',
      buyer_detail: '바이어 상세',
      styleNo: '스타일 번호',
      fileNo: '파일 번호',
      orderReceivedDate: '오더 수신일',
      expectedDeliveryDate: '납기 예정일',
      fx_base_currency: '환율 기준 통화',
      fx_quote_currency: '환율 상대 통화',
      fx_rate: '환율',
      fetchFxRate: '고시환율 불러오기',
      applyFxRate: '환율 적용',
      fxRateFetchFailed: '환율 조회에 실패했습니다.',
      date: '날짜',
      item: '품목',
      size: '사이즈',
      color: '컬러명',
      quantity: '수량',
      currency: '통화',
      unitPrice: '단가',
      noPriceData: '단가 데이터 없음',
      priceSelectTitle: '단가 선택',
      code: '코드',
      totalPrice: '총액',
      actions: '작업',
      orderInfo: '오더 정보',
      searchConditions: '검색 조건',
      weight: '무게',
      items: '항목',
      orderDate: '오더 날짜',
      total: '총액',
      sum: '합계',
      remark: '비고',
      searchOrderId: '오더 번호 입력'
    },
    files: {
      selectedCount: '{{count}}개 파일 선택됨',
      selectTooltip: '파일 업로드',
      uploading: '파일 업로드 중...',
      loading: '파일 목록 로딩 중...',
      uploadErrorTitle: '파일 업로드 실패',
      uploadFailure: '오더 ID: {{orderId}}\n파일 업로드에 실패했습니다.\n실패한 파일: {{failedFiles}}',
      uploadPartialFailure: '오더 ID: {{orderId}}\n일부 파일 업로드에 실패했습니다.\n성공: {{successCount}}/{{totalCount}}\n실패한 파일: {{failedFiles}}',
      title: '첨부 파일',
      noFiles: '첨부 파일이 없습니다.',
      existingFile: '기존 파일'
    },
    columns: {
      no: '번호',
      date: '날짜',
      orderNo: '오더 번호',
      custom: '고객사',
      buyer: '바이어',
      styleNo: '스타일 번호',
      fileNo: 'FILE NO.',
      vendorName: 'CUSTOMER',
      factory: '입고처',
      name: '담당자',
      item: '품목',
      size: '사이즈',
      color: '컬러명',
      dyeNo: '염색 번호',
      dyeingStatus: '염색 공정 상태',
      yarnEa: '원사 수량',
      inventory: '재고',
      totalQty: '총 수량',
      unitPrice: '단가',
      totalPrice: '총액',
      swatchDate: '스와치 수취 일자',
      sampleDate: '샘플 발송 일자',
      confirmDate: '컨펌 일자',
      shippingDate: '출고 일자',
      deliveryDate: '출고일',
      shippedQty: '출고 수량',
      remainingQty: '잔여 수량',
      shippingSampleDate: '출고 배송 날짜',
      remark: '비고',
      status: '상태'
    },
    validation: {
      required: '필수 항목입니다',
      invalidNumber: '유효하지 않은 숫자입니다'
    },
    messages: {
      saveSuccess: '오더가 성공적으로 저장되었습니다',
      saveSuccessWithFileUpload: '오더 ID: {{orderId}}\n오더가 성공적으로 저장되었습니다.',
      saveFail: '오더 저장에 실패했습니다',
      errorOrderId: '오더 번호는 필수 항목입니다',
      searchSuccess: '오더 정보를 성공적으로 불러왔습니다',
      deleteSuccess: '오더가 삭제되었습니다',
      deleteFail: '오더 삭제에 실패했습니다',
      deleteConfirm: '오더를 삭제하시겠습니까?',
      updateSuccess: '오더가 성공적으로 수정되었습니다'
    },
    delete: {
      title: '오더 삭제',
      confirmMessage: '오더를 삭제하시겠습니까?'
    },
    confirm: {
      title: '확인',
      editTitle: '수정 사항 확인'
    },
    viewMode: {
      on: 'Ex',
      off: 'Basic'
    },
    filterAddCurrent: '현재 선택 내용을 필터에 추가',
    customerRequired: '업체명을 먼저 선택해주세요.',
    statusTabs: {
      basic: '기본',
      detail: '상세'
    },
    selfConfirm: '자체 컨펌',
    myOrderFilter: {
      on: 'My',
      off: 'All'
    },
    orderStatus: {
      columns: {
        scmDeliveryStatus: '배송 상태',
        scmDeliveryDate: '배송일',
        scmDeliveryQty: '배송 수량'
      },
      errors: {
        deliveryFetchFailed: '배송 정보 조회에 실패했습니다.'
      }
    },
    columnSettings: '컬럼 설정',
    status: {
      pending: '대기 중',
      swatchWaiting: '스와치 대기중',
      dyeingWaiting: '염색 대기중',
      processWaiting: '작업 대기중',
      inProgress: '진행 중',
      rework: '재작업',
      completed: '완료',
      checkingResult: '색상 검사',
      dehydrationWaiting: '건조 대기중',
      dehydrationInProgress: '건조 진행중',
      dehydratingInProgress: '탈수 진행중',
      locationNeeded: '위치 지정 필요',
      rackingWaiting: '보관 대기중',
      stacking: '보관중',
      vendorChecking: '벤더 확인중',
      vendorConfirmed: '벤더 승인',
      vendorRejected: '벤더 거절',
      colorRejected: '색상 거절',
    },
    confirm: {
      title: '확인',
    }
  },

  swatch: {
    shippingSampleComingSoon: '준비 중',
    flow: {
      noProcess: '진행 내역이 없습니다.',
      dyeWaiting: '염색 대기',
      dyeingInProgress: '염색 진행중',
      recipeAdding: '레시피 추가중',
      rackWaiting: '보관 대기중',
      redyed: '재염색',
      workCancelled: '작업 취소',
      waiting: '대기',
      approved: '승인',
      rejected: '리젝',
      colorFailed: '컬러 실패',
      send: '발송',
      sendCancel: '발송 취소',
      approve: '승인',
      reject: '리젝',
      resultCancel: '결과 취소',
      remaining: '남은 작업 수량',
      undecided: '미결정'
    },
    filterTitle: '검색 조건',
    noData: '데이터가 없습니다.',
    fields: {
      customer: '고객사',
      buyer: '바이어',
      styleNo: '스타일 번호',
      fileNo: '파일 번호',
      factory: '공장',
      manager: '담당자',
      item: '아이템',
      color: '색상',
      quantity: '수량'
    },
    columns: {
      subOrderId: 'Sub Order ID',
      customer: '고객사',
      buyer: '바이어',
      styleNo: '스타일 번호',
      fileNo: '파일 번호',
      factory: '공장',
      manager: '담당자',
      item: '아이템',
      color: '색상',
      quantity: '수량',
      activeProductionId: 'Active Production ID',
      activeStatus: 'Active Status',
      rejectCount: 'Reject #',
      confirmStatus: 'Confirm',
      actions: '작업',
      productionId: 'Production ID',
      status: 'Status',
      updatedAt: 'Updated At',
      dyeingNo: 'DYEING NO'
    },
    vendorConfirm: {
      title: '벤더 컨펌 등록 ({{count}}개 항목)',
      selectedItemInfo: '선택된 항목 정보',
      dyeingWorkHistory: '염색 작업 내역 및 벤더 컨펌',
      vendorConfirm: '벤더 컨펌',
      processing: '처리 중...',
      pleaseWait: '잠시만 기다려주세요',
      register: '등록',
      edit: '수정',
      confirm: 'Confirm',
      reject: 'Reject',
      selfConfirm: '자체 컨펌',
      selfReject: '자체 리젝',
      sendSample: '샘플 발송',
      vendorApprove: '벤더 컨펌',
      vendorReject: '벤더 리젝',
      select: '선택',
      statusChecking: '벤더 확인 중',
      statusStored: '보관',
      statusDone: '완료',
      statusRejected: '반려',
      decision: '컨펌 선택',
      undecided: '미결정',
      rejected: '거절',
      noItemsToModify: '수정할 항목이 없습니다.',
      vendorConfirmRegistered: '벤더 컨펌이 등록되었습니다.',
      registrationFailed: '벤더 컨펌 등록에 실패했습니다: {{error}}',
      cancelReview: '검토 취소',
      cancelFailed: '취소 이벤트 전송에 실패했습니다: {{error}}'
    },
    tableControls: {
      itemsSelected: '{{count}}개 항목 선택됨',
      noItemsSelected: '선택된 항목 없음',
      vendorConfirmTooltip: '벤더 컨펌 등록 ({{count}}개)',
      columnSettings: '컬럼 설정',
      selectAll: '전체 선택',
      unselectAll: '전체 해제'
    },
    detail: {
      title: 'Swatch 상세 정보',
      basicInfo: '기본 정보',
      statusApproved: '승인',
      statusRejected: '거부',
      statusPending: '대기',
      fields: {
        subOrderId: 'Sub Order ID',
        dyeingNo: 'Dyeing NO',
        customer: '고객사',
        buyer: '바이어',
        styleNo: '스타일 번호',
        fileNo: '파일 번호',
        factory: '공장',
        manager: '담당자',
        item: '아이템',
        color: '색상',
        quantity: '수량'
      },
      summary: {
        title: '염색 진행상황 요약',
        dyeingNo: 'Dyeing NO',
        activeProductionId: 'Active Production ID',
        activeStatus: 'Active Status',
        rejectCount: 'Reject #',
        confirmStatus: 'Confirm',
        confirmed: '승인됨',
        notConfirmed: '미승인'
      },
      history: {
        title: '염색 작업 내역',
        productionId: 'Production ID',
        status: '상태',
        statusDesc: '상태 설명',
        updatedAt: 'Updated At',
        remark: '비고',
        empty: '염색 작업 내역이 없습니다.'
      }
    }
  },

  dyeing: {
    title: '염색 작업',
    tabs: {
      batchRequest: '일괄 요청',
      internalProduction: '내부 생산 오더',
      requestStatus: '요청 현황'
    },
    assignWork: {
      label: '작업 배정',
      tooltip: '클릭 시 염색 번호가 부여 됩니다.',
      click: '생성'
    },
    fields: {
      searchConditions: '검색 조건',
      dyeingNo: '염색 번호',
      productionNo: '생산 번호'
    },
    requests: {
      request: '작업 배정',
      delete: '삭제',
      modify: '수정',
      createDyeingNumbers: '염색 번호 생성'
    },
    worker: {
      enterUserId: '사용자 ID를 입력하고 연결해 주세요.',
      userId: '사용자 ID',
      retryConnection: '다시 연결',
      tokenExpired: '연결이 만료되었습니다. 아래 버튼으로 다시 연결해 주세요.',
      tokenFailed: '접속 토큰을 받지 못했습니다.',
      userNotFound: '존재하지 않는 사용자 ID입니다.',
      operator: '작업자',
      showHistory: '완료/리젝 이력 표시',
      invalidCredentials: '관리자 승인이 필요합니다.\n관리자에게 문의해 주세요.',
      networkError: '서버에 연결할 수 없습니다. 네트워크를 확인해 주세요.',
      loginButton: '로그인',
      loadingWork: '작업을 불러오는 중입니다...',
      recipeLocked: '염색 공정중에는 레시피 변경이 불가능합니다',
      searchResultTitle: '검색 결과',
      searchNoResult: '검색 결과가 없습니다.'
    },
    status: {
      showCompleted: '작업 완료 표시'
    },
    tableRow: {
      work: '작업',
      number: 'No',
      enterNumber: '번호 입력',
      confirm: '컨펌',
      stock: '재고',
      size: 'SIZE',
      pcs: 'PCS',
      remark: 'REMARK'
    },
    workType: {
      swatch: 'SWATCH',
      repeat: 'REPEAT'
    },
    confirmationType: {
      vendor: 'VENDOR',
      self: 'SELF'
    },
    stockType: {
      na: 'N/A',
      stock_black: 'STOCK BLACK',
      opt: 'OPT',
      opt_white: 'OPT',
      ivory: 'IVORY'
    },
    messages: {
      updateSuccess: '염색 요청이 성공적으로 업데이트되었습니다',
      updateFail: '염색 요청 업데이트에 실패했습니다',
      abnormalSelection: '선택한 항목에 비정상적인 항목이 있습니다',
      deleteSuccess: '염색 요청이 성공적으로 삭제되었습니다',
      deleteFail: '염색 요청 삭제에 실패했습니다',
      deleteFailed: '삭제에 실패했습니다.',
      requestSuccess: '염색 요청이 성공적으로 전송되었습니다',
      requestFail: '염색 요청 전송에 실패했습니다',
      noNewItems: '새로운 항목이 선택되지 않았습니다',
      onlyNewItems: '신규 항목만 등록 가능합니다',
      selectItemsToPrint: '인쇄할 항목을 선택하세요',
      noDyeingItemsSelected: '선택된 염색 항목이 없습니다',
      missingSampleDetails: '일부 항목의 SAMPLE SIZE 또는 QTY가 입력되지 않았습니다',
      excelSheetWillBeAdded: 'Excel 시트 추가 할 예정',
      noPrintableItems: '인쇄할 항목이 없습니다',
      deleteConfirm: '염색 요청을 삭제하시겠습니까?',
      noItemsSelected: '선택된 항목이 없습니다',
      selectItems: '항목을 선택해주세요',
      invalidDeleteOrder: '다음 항목들은 삭제할 수 없습니다: {{items}}',
      dyeingReadyCompleted: '염색 준비가 완료되었습니다.',
      dyeingStarted: '염색 작업이 시작되었습니다.',
      dyeingFinished: '염색 작업이 완료되었습니다.',
      recipeLoadFailed: '레시피 정보를 불러오지 못했습니다.',
      saveFailed: '저장에 실패했습니다.',
      recipeModifyCompleted: '레시피 수정이 반영되어 염색 준비 상태로 복귀했습니다.',
      operationCanceled: '염색 작업이 취소되었습니다.',
      dehydrationStarted: '탈수 작업이 시작되었습니다.',
      dehydrationFinished: '탈수 작업이 완료되었습니다.',
      colorConfirmed: '컬러가 컨펌 되었습니다.',
      colorDefectRecorded: '색상 불량으로 등록되었습니다. 레시피 수정 후 재염색하세요.',
      dyeingAborted: '염색이 중단되었습니다. 새 작업번호를 생성할 수 있습니다.',
      workRejected: '작업이 리젝 되었습니다. 새 작업 항목을 생성하세요',
      locationAssigned: '보관 위치가 지정되었습니다.',
      cannotModifyCompleted: '이미 작업이 완료된 항목은 수정할 수 없습니다.',
      cannotModifyInProgress: '작업이 진행 중인 항목은 수정할 수 없습니다.',
      cannotDeleteCompleted: '이미 작업이 완료된 항목은 삭제할 수 없습니다.',
      cannotDeleteInProgress: '작업이 진행 중인 항목은 삭제할 수 없습니다.',
      recipeSaveSuccess: '레시피가 성공적으로 저장되었습니다.',
      multiRecipeSaveSuccess: '{{successCount}}개의 레시피가 성공적으로 저장되었습니다.',
      multiRecipeSavePartial: '{{successCount}}개의 레시피가 성공, {{failCount}}개의 레시피가 실패했습니다.',
      recipeSaveFailed: '레시피 저장에 실패했습니다.',
      productionIdsRequired: '추가할 SPK가 없습니다.',
      addingToExistingRecipe: '기존 레시피에 추가 중...',
      quantityChangeSuccess: '작업 수량이 성공적으로 변경되었습니다.',
      selectOneItemForEdit: '편집할 항목을 하나만 선택해주세요',
      noRecipeToEdit: '편집할 레시피가 없습니다',
      confirmDeleteRecipe: '레시피를 삭제하시겠습니까?',
      deleteRecipeFailed: '레시피 삭제에 실패했습니다.',
      recipeDeleteSuccess: '레시피가 성공적으로 삭제되었습니다.',
      vendorColorConfirmed: '벤더 컬러가 컨펌 되었습니다.',
      vendorRejected: '벤더가 거절했습니다.',
      rawYarnNotSelected: '원사 선택에 문제가 있습니다. 염색 요청을 재생성하거나 수정해주세요'
    },
    machine: {
      waiting: '대기중',
      working: '작업 중',
      mcLabel: 'M/C {{number}}',
      mcNotAssigned: 'M/C 대기',
      selectMachine: 'M/C 배치'
    },
    monitoring: {
      elapsedTime: '경과 시간',
      exceededTimeLimit: '시간 제한 초과',
      noActiveDyeing: '활성 염색 없음',
      nextWork: '다음 작업',
      filterStatus: '상태 필터',
      filterAll: '모든 기계',
      filterIdle: '대기 중인 기계',
      filterWorking: '작업 중인 기계'
    },
    operation: {
      title: '염색 작업',
      operationTab: '작업',
      boilingRecordsTab: '끓임 기록',
      startWork: '작업 시작',
      recordResult: '결과 기록',
      resultType: '결과 유형',
      notes: 'Remark',
      selectedItemsCount: '{{count}}개 항목 선택됨',
      noItemsSelected: '선택된 항목 없음',
      issueWorkNumber: '작업번호발급',
      delete: '삭제',
      registerRecipe: '레시피 등록',
      editRackCode: '랙 코드 수정',
      rackCodeLabel: '랙 코드',
      rackDialog: {
        noProductionId: 'production_id가 없어 랙 코드를 수정할 수 없습니다.',
        saveFailed: '랙 코드 저장에 실패했습니다.'
      },
      processQuantityDialog: {
        title: '작업 수량 설정',
        dyeingNo: '염색 번호',
        totalOrderQuantity: '총 주문 수량',
        workQuantity: '작업 수량',
        workQuantityHelper: '이번에 작업할 수량을 입력하세요 (소수점 가능)',
        remainingQuantity: '남은 수량',
        remainingQuantityNote: '(남은 수량은 새 작업 항목으로 자동 생성됩니다)',
        applyExistingRecipe: '기존 레시피 적용 (선택)',
        selectRecipe: '레시피 선택',
        doNotApply: '적용 안 함',
        recipeCopyNote: '* 선택 시 해당 레시피와 동일한 레시피가 자동으로 생성됩니다.',
        enterWorkQuantity: '작업 수량을 입력해주세요.',
        workQuantityRange: '작업 수량은 0 이상 {{max}} 이하의 숫자여야 합니다.',
        recipeCopyFailed: '작업은 생성되었으나 레시피 복사에 실패했습니다.',
        processQuantityFailed: '작업 수량 설정에 실패했습니다.'
      },
      batchDialog: {
        title: '염색번호로 작업/레시피 일괄 생성',
        reworkTitleSuffix: ' (기존 레시피 {{recipeIdShort}} 활용)',
        reworkRunNumber: '이번 생성: recipe run {{n}}번째',
        reworkLabel: '이번 생성: 재작업',
        searchByDyeingNo: '염색번호(dyeing_no_short)로 검색',
        unassignedOnly: '미할당',
        recipeSelect: '레시피 선택',
        recipeNew: 'NEW',
        machineLabel: 'MC',
        machineNotSet: '미지정',
        selectedItems: '선택된 항목',
        searchResults: '검색 결과',
        noData: '검색 결과가 없습니다.',
        createWorkOnly: '작업 번호만 일괄 생성',
        createWorkAndRecipe: '작업 번호 + 멀티 레시피',
        noRowsSelected: '선택된 염색 요청이 없거나 작업 수량이 0인 항목만 있습니다.',
        submitFailed: '작업 번호 생성 중 오류가 발생했습니다.',
        headers: {
          dyeingNo: 'DYEING NO',
          style: 'STYLE',
          customer: 'CUSTOMER',
          item: 'ITEM',
          color: 'COLOR',
          reqQty: 'REQ QTY',
          workQty: 'WORK QTY',
          action: 'ACTION'
        },
        tooltips: {
          remove: '제거',
          select: '선택',
          deselect: '선택 해제'
        }
      },
      editRecipe: '레시피 수정',
      printRecipe: '레시피 출력',
      printCardsOnly: '와인딩 카드만 출력',
      extraWindingCards: '와인딩 카드 추가 장수 (아이템당)',
      extraWindingCardsRequired: '추가 출력할 장수를 입력해주세요.',
      netWeightMissingTitle: 'net_weight 미등록',
      netWeightMissingBlocked: '{{items}}의 net_weight을 품목 관리에서 입력해주세요. 등록 전까지 레시피 출력이 제한됩니다.',
      splitOrder: '주문 분할',
      splitQuantity: '분할 수량',
      splitHelp: '첫 번째 로트의 수량을 입력하세요',
      pending: '대기',
      waiting: '대기',
      processing: '진행중',
      drying: '건조',
      deliveryWaiting: '배송 대기',
      deliveryProcessing: '배송 진행',
      completed: '완료',
      cancelled: '취소'
    },
    recipeRegisterOption: {
      title: '레시피 등록',
      subtitle: '등록 방식을 선택하세요.',
      new: '신규 생성',
      addToExisting: '기존 레시피에 추가',
      copyDyeOnly: '기존 레시피에서 염료만 복사'
    },
    addToExisting: {
      subtitle: '추가할 레시피를 선택하세요.',
      recipeId: '레시피 ID',
      dyeingNoShortList: '염색번호 목록',
      noRecipes: '조회된 레시피가 없습니다.',
      loadError: '레시피 목록을 불러오지 못했습니다.',
      searchByDyeingNo: '염색번호(dyeing_no_short)로 검색',
      searchAriaLabel: 'dyeing_no_short 검색'
    },
    boilingRecords: {
      startDateTime: '시작 일시',
      endDateTime: '종료 일시',
      search: '조회',
      dateRequired: '시작 및 종료 일시를 입력하세요',
      invalidDateRange: '시작 일시는 종료 일시보다 이전이어야 합니다',
      chartTitle: '기계별 끓임 기간 타임라인',
      noData: '선택한 기간에 끓임 기록이 없습니다',
      machineNo: '기계 번호',
      productionId: '생산 ID',
      dyeingNo: '염색 번호',
      recipeId: '레시피 ID',
      boilingStart: '끓임 시작',
      boilingEnd: '끓임 종료',
      duration: '소요 시간',
      editDialogTitle: '끓임 시각 수정',
      modify: '수정',
      modifySuccess: '끓임 시각이 수정되었습니다.',
      modifyFailed: '끓임 시각 수정에 실패했습니다.',
      zoomHelp: '확대/축소 버튼을 사용하거나 차트를 드래그하여 이동하세요 (Zoom: {{zoom}}x)'
    },
    modals: {
      createDyeingNumbers: {
        title: '염색 번호 생성',
        description: '선택된 항목들에 대한 염색 번호를 생성합니다.',
        submit: '염색 번호 생성',
        cheeseBaseValue: '기준값: {{value}}'
      },
      modifyDyeingNumbers: {
        title: '염색 요청 수정',
        description: '선택된 항목들의 염색 요청 정보를 수정합니다.',
        submit: '수정',
        cheeseBaseValue: '기준값: {{value}}'
      }
    },
    recipe: {
      title: '염색 레시피 등록',
      searchOrSelectDyestuff: '염료 검색/선택',
      addColorReductionRows: '색환원 행 추가',
      removeColorReductionRows: '색환원 행 제거',
      enterNotes: '메모를 입력하세요...',
      inventoryTx: {
        title: '재고 이동 현황',
        empty: '재고 이동 내역이 없습니다.',
        loadFailed: '재고 이동 내역을 불러오지 못했습니다.',
        loadMore: '더 보기',
        noProductionIds: '연결된 작업(production)이 없어 조회할 수 없습니다.',
        truncatedWorkIds: '작업이 {{max}}건을 넘어 앞 {{max}}건만 조회합니다.',
        columns: {
          txTime: '이동 시각',
          txType: '유형',
          item: '품목',
          qty: '수량',
          uom: '단위',
          from: '출고 위치',
          to: '입고 위치'
        }
      },
      totalPercent: 'TOTAL %',
      program: 'PROGRAM',
      addRevision: '리비전 추가',
      viewEdit: '레시피',
      search: {
        title: '레시피 검색'
      },
      fields: {
        recipeIdShort: '레시피 ID',
        recipeId: '레시피 ID',
        productionIds: '생산 ID',
        dyeStuff: 'DYE STUFF',
        chemicals: 'CHEMICAL',
        acid: 'ACID',
        note: '비고',
        createdBy: '생성자',
        createdAt: '생성일시',
        dyeingNo: '염색 번호'
      },
      errors: {
        fetchFailed: '레시피 목록을 가져오는데 실패했습니다.'
      },
      selectedItemsCount: '{{count}}개 레시피 선택됨',
      noItemsSelected: '선택된 레시피 없음',
      selectionMode: '선택 모드',
      clickToSelect: '클릭하여 선택',
      clickToDeselect: '클릭하여 선택 해제',
      clickToSelectAll: '클릭하여 전체 선택/해제',
      editRecipe: '레시피 수정',
      viewRecipe: '레시피 상세',
      savingMessage: '레시피 정보를 저장하고 있습니다. 잠시만 기다려주세요.',
      multiRecipe: {
        title: '멀티 염색 레시피 등록',
        sameWork: '동일 작업',
        workingDate: 'WORKING DATE',
        urgent: 'URGENT',
        customer: 'CUSTOMER',
        dyeingNo: 'DYEING NO',
        productionNo: 'PRODUCTION NO',
        color: 'COLOR',
        note: 'NOTE',
        dyeClass: 'Dye Class',
        item: 'Item',
        qty: 'Qty',
        net: 'Net(kg)',
        dyestuff: 'Dyestuff',
        percentage: '%',
        gram: 'Gram',
        total: 'TOTAL',
        chemical: 'CHEMICAL',
        rc: 'R/C',
        selectItem: '아이템 선택',
        acid: 'ACID',
        acidSection: 'ACID',
        hydro: 'HYDRO',
        naoh: 'NAOH',
        lot: 'LOT'
      },
      validation: {
        saveConditionFailed: '저장 조건을 만족하지 않습니다. 입력값을 확인해주세요.',
        invalidRecipe: '레시피를 완성해주세요.',
        noDyestuffAndPercentage: '염료와 비율을 입력해주세요.',
        noDyestuff: '염료를 입력해주세요.',
        noPercentage: '비율을 입력해주세요.',
        missingPercentage: '염료에 대한 비율을 입력해주세요.',
        invalidDyestuff: '유효하지 않은 염료입니다.'
      },
      skuWarning: {
        title: 'SKU 누락 경고',
        message: '다음 항목의 SKU가 없어 저장할 수 없습니다:',
        excludedMessage: 'SKU가 없는 항목은 제외하고 저장됩니다.',
        dyestuff: '염료',
        chemical: '화학약품',
        unknown: '알 수 없음'
      },
      windingCardPrint: {
        title: '와인딩 카드 프린트 설정',
        waitingItems: '프린트 대기',
        allItemsAssigned: '모든 항목 할당됨',
        newGroup: '새 그룹',
        groupName: '그룹',
        individual: '개별',
        itemsCount: '{{count}}개 항목',
        count: '{{count}}개',
        assignInstruction: '위의 대기 항목을 클릭하여 그룹에 할당하세요',
        recipeLabel: '레시피',
        singleRecipeInfo: '+ 단일 레시피 {{count}}개 (설정 없이 바로 출력)'
      }
    },
    result: {
      title: '결과',
      selectResultMessage: '염색 작업 결과를 선택해주세요.',
      selectCheckingMessage: '염색 확인 결과를 선택해주세요.',
      approve: '염색 확인',
      colorDefect: '색상 불량',
      colorDefectHint: '조제 수정 후 같은 작업번호로 재염색',
      dyeingAbort: '새 원사로 작업',
      dyeingAbortHint: '작업번호 신규 생성 필요',
      dyeingAbortConfirmTitle: '염색 중단 확인',
      dyeingAbortConfirmMessage: '염색 중단 후에는 취소(되돌리기)가 불가능합니다.\n정말 염색 중단으로 처리하시겠습니까?',
      dyeingAbortConfirmProceed: '염색 중단',
      reject: '거절',
      add: '추가',
      new: '신규'
    },
    location: {
      title: '보관 위치',
      titleRegister: '보관 위치 등록',
      enterLocationMessage: '완료된 작업의 보관 위치를 입력해주세요.',
      locationLabel: '보관 위치',
      locationPlaceholder: '예: A1, B2-3, C5',
      locationHelperText: '보관 위치 코드를 입력하세요.',
      confirmMessage: '{{location}} 위치에 보관하시겠습니까?',
      applyToAllDyeingNo: '모든 염색 번호에 대해 동일한 적용'
    },
    success: {
      machineAssigned: '기계가 성공적으로 배정되었습니다',
      operationStarted: '작업이 성공적으로 시작되었습니다',
      resultRecorded: '결과가 성공적으로 기록되었습니다',
      orderSplit: '주문이 성공적으로 분할되었습니다'
    },
    errors: {
      noItemsSelected: '하나 이상의 항목을 선택해주세요',
      noMachineAssigned: '선택한 모든 항목에 기계를 배정해주세요',
      machineAssignFailed: '기계 배정에 실패했습니다',
      operationStartFailed: '작업 시작에 실패했습니다',
      resultRecordFailed: '결과 기록에 실패했습니다',
      dyeingAbortFailed: '염색 중단 처리에 실패했습니다',
      orderSplitFailed: '주문 분할에 실패했습니다',
      requestFailed: '염색 요청 실패',
      errorResponse: '오류 응답',
      statusCode: '상태 코드',
      requestError: '요청 오류',
      setupError: '설정 오류',
      updateFailed: '염색 요청 업데이트 실패',
      deleteFailed: '염색 요청 삭제 실패',
      printError: '인쇄 오류',
      updateOperationFailed: '업데이트 중 오류 발생',
      requestOperationFailed: '요청 중 오류 발생',
      deleteOperationFailed: '삭제 중 오류 발생',
      dyeingReadyFailed: '염색 준비 완료 처리에 실패했습니다.',
      dyeingStartFailed: '염색 작업 시작에 실패했습니다.',
      recipeModifyFailed: '레시피 수정 반영에 실패했습니다.',
      machineAlreadyInUse: 'M/C {{machine}}번에서 레시피 {{recipe}} 작업이 이미 진행 중입니다.\n다른 작업이 끝난 뒤 시작해 주세요.',
      dyeingFinishFailed: '염색 작업 종료에 실패했습니다.',
      cancelFailed: '염색 작업 취소에 실패했습니다.',
      dehydrationStartFailed: '탈수 작업 시작에 실패했습니다.',
      dehydrationFinishFailed: '탈수 작업 종료에 실패했습니다.',
      locationAssignFailed: '보관 위치 지정에 실패했습니다.',
      processEventFailed: '염색 공정 이벤트 처리에 실패했습니다.',
      eventConflict: '다른 작업자가 이 작업을 처리 중입니다. 잠시 후 다시 시도하세요.',
      eventJobTimeout: '처리가 시간 내에 완료되지 않았습니다. 목록을 새로고침한 뒤 상태를 확인해 주세요.',
      eventApplyFailed: '처리 실패. 상태는 변경되지 않았습니다.',
      inventoryPreflightFailed: '재고가 부족합니다.',
      inventoryFailureLine: '{{itemName}} 필요 {{required}} / 가용 {{available}}',
      inventoryFailureLineWithLocation:
        '{{itemName}} ({{locationName}} #{{locationId}}) 필요 {{required}} / 가용 {{available}}',
      inventoryLocationNotFound: '입고 위치를 찾을 수 없습니다: {{locationName}} (#{{locationId}})',
      printFailed: '프린트에 실패했습니다.',
      noRecipeToPrint: '출력할 레시피가 없습니다.',
      bulkPrintFailed: '일괄 레시피 출력에 실패했습니다.'
    },
    eventProcessing: '처리 중…',
    status: {
      showCompleted: '작업 완료 표시',
      title: '염색 현황',
      statusTab: '현황',
      monitoringTab: '실시간 모니터링',
      statisticsTab: '통계',
      inventoryTab: '재고 현황',
      inventoryStartDate: '시작일',
      inventoryEndDate: '종료일',
      inventoryOpening: '시작 잔고',
      inventoryClosing: '종료 잔고',
      inventoryReceipt: '입고',
      inventoryIssue: '출고',
      inventoryProduction: '생산',
      inventoryConsume: '소진',
      inventoryTotal: '합계',
      inventoryDate: '날짜',
      inventoryRangeRequired: '시작일과 종료일을 선택하세요.',
      inventoryRangeTooLong: '조회 기간은 31일 이하여야 합니다.',
      inventoryRangeInvalid: '종료일이 시작일보다 빠릅니다.',
      inventorySnapshotPending: '마감 준비 중입니다.',
      inventoryStale: '소급 거래 반영 전',
      inventoryCloseTz: '마감 기준 {{tz}}',
      inventoryCalendarNote: '{{start}} ~ {{end}} · 자카르타 날짜 ({{tz}})',
      inventoryMixedUom: '단위가 다른 수량을 더한 합계입니다.',
      inventoryLoadFailed: '재고 현황을 불러오지 못했습니다.',
      inventoryLocationMissing: '창고를 찾을 수 없습니다. {{detail}}',
      inventorySnapshotMonth: '기초 마감월 {{month}}',
      inventorySnapshotAt: '마감 생성 {{at}}',
      machineQueueTab: '기계별 대기',
      machineQueueTitle: 'MACHINE QUEUE',
      queueReorder: '정렬',
      queueReordering: '정렬 중...',
      queueInProgress: '진행 중',
      queueWaiting: '대기',
      queuePlacement: '기계 배치전',
      queueReady: '원사 준비 완료',
      queueDyeing: '작업 진행중',
      queuePostDyeing: '탈수/건조/보관',
      queueDelivery: 'Delivery',
      queueReadOnlyHint: '순서 변경은 관리자·염색 부서만 가능합니다',
      queueMoveSuccess: '대기 순서가 변경되었습니다',
      queueMoveFailed: '순서 변경에 실패했습니다',
      queuePollNote: '※ 30초마다 자동 갱신됩니다',
      queueEmptyMachine: '대기 작업 없음',
      queueActiveMachines: '작업 중인 기계',
      queueDetailItems: 'Item',
      queueDetailDyeingNo: 'Dyeing No',
      queueDetailStyle: 'Style',
      queueDetailColor: 'Color',
      queueDetailCustomer: 'Customer',
      queueDetailDyeingRequestAt: '염색 요청 시간',
      queueDetailGiRequestAt: '출고 요청 시간',
      queueDetailBoiling: '염색 시작',
      queueDetailRunInProgress: '작업중',
      queueDetailRunWaiting: '작업 대기중',
      queueDetailRecipeModifying: '레시피 수정중',
      queueDetailRecipeModified: '레시피 변경 완료',
      queueDetailLoadFailed: '상세 정보를 불러오지 못했습니다',
      queueUrgentOverride: '긴급 표시 덮어쓰기',
      queueUrgentOverrideFailed: '긴급 표시 변경에 실패했습니다',
      statisticsComingSoon: '통계 차트 준비 중',
      expand: '펼치기 (+{{count}})',
      collapse: '접기',
      dataRangeNote: '※ 기본 데이터는 오늘 기준 최근 7일만 표시됩니다. 더 과거 날짜는 선택 시 자동 조회됩니다.',
      completedDataNote: '※ 완료 이력은 선택한 날짜·브라우저 시간대 기준으로 조회됩니다.',
      shiftLegend: 'Shift',
      excelRangeTitle: '엑셀 다운로드 기간',
      shift1: '1 Shift (06:00–14:00)',
      shift2: '2 Shift (14:00–22:00)',
      shift3: '3 Shift (22:00–06:00)',
      pending: '대기 중',
      inProgress: '진행 중',
      completed: '작업 완료',
      idle: '대기',
      working: '작업 중',
      reject: 'REJECT',
      dyeingAborted: 'DYEING ABORT',
      dyeingAbortedHint: '염색 중단 — 새 작업번호 생성 가능',
      modifying: 'MODIFYING',
      rackWaiting: '보관 위치 대기',
      rackWaitingLocation: '염색 확인 완료 [보관 위치 대기중]',
      dehydrationComplete: '탈수 완료',
      approvalComplete: '승인 완료',
      dehydrating: '탈수중',
      swatchWaiting: 'Swatch 배송 대기중',
      dyeingComplete: '염색 완료',
      dyeingInProgress: '염색중',
      workWaiting: '작업 대기중',
      rawYarnPreparing: '원사 준비중',
      recipeModifying: '레시피 수정중',
      preparing: '작업 준비',
      preparationNeeded: '모든 조건 충족 필요',
      approvalNeeded: '결과 입력대기',
      dehydrationPending: '탈수 대기중',
      locationPending: '보관 대기중',
      dehydratingShort: '탈수',
      dyeingShort: '염색중',
      selectMachine: '기계를 선택해주세요.',
      waitingForAssignment: '작업 배치 대기중',
      ready: '작업 준비',
      dyeingCompleteChecking: '염색 작업 완료 [확인중]',
      approvalCompleteDehydrationWaiting: '컬러 승인 [탈수 대기]',
      dehydrationCompleteLocationWaiting: '탈수 완료 [보관 위치 대기중]',
      completedWithLocation: '작업 완료 [{{location}}]',
      vendorChecking: '벤더 확인중',
      vendorConfirmed: '벤더 승인',
      vendorRejected: '벤더 거절',
      filter: {
        pending: '작업 전',
        ready: '작업 준비',
        dyeing: '염색 중',
        approval: '결과 확인',
        dehydration: '탈수',
        location: '위치 대기',
        completed: '작업 완료',
        rejected: 'REJECT'
      }
    },
    actions: {
      assignLocation: '보관',
      markDyeingReady: '염색 준비',
      prepareComplete: '준비 완료',
      recipeModifyDone: '수정 완료',
      startDehydration: '탈수 시작',
      finishDehydration: '탈수 완료',
      viewResults: '작업 결과',
      enterResults: '결과 입력',
      startOperation: '작업 시작'
    },
    tooltip: {
      readyCondition: '수량, 레시피 및 기계가 모두 지정되어야 염색 준비가 가능합니다.',
      startCondition: '염색 준비 완료 후 시작할 수 있습니다.'
    },
    filter: {
      showAll: '모든 항목',
      showDyeingOnly: '염색번호 O',
      showWithoutDyeing: '염색번호 X'
    },
    print: {
      dyeingRequest: 'DYEING REQUEST',
      leader: 'Leader',
      manager: 'Manager',
      itemSize: 'ITEM_SIZE',
      qty: 'QTY',
      dyeNo: 'DYE NO.',
      color: 'COLOR',
      cheese: 'CHEES',
      priority: 'PRIORITY',
      urgent: 'URGENT',
      standard: 'STANDARD',
      data: 'DATA',
      dyeingBT: 'DYEING B/T',
      remark: 'REMARK',
      dyeingLabel: 'DYEING LABEL',
      preparingPrint: '인쇄 준비 중...',
      printReady: '인쇄 준비 완료',
      print: '작업지시서',
      exportToExcel: 'Excel 내보내기',
      excel: 'Excel',
      printLabels: '라벨 인쇄',
      label: 'Label',
      printConfirmationCard: '컨펌 카드 인쇄',
      sheet: 'Sheet',
      printDyeingInstructions: '염색지시서 인쇄',
      printConfirmSheet: '컨펌 시트 인쇄',
      selectedItemsCount: '{{count}}개 항목 선택됨',
      noItemsSelected: '선택된 항목 없음',
      confirmCard: {
        title: '컨펌 카드 인쇄 설정',
        selectedItems: '선택된 항목: {{count}}개',
        templateSelect: '템플릿 선택',
        includeBuyerDetail: '바이어 상세 포함',
        templates: {
          standard: 'STANDARD',
          hansoll: 'HANSOLL',
          seaA: 'SEA-A',
          shinsung: 'SHINSUNG',
          mca: 'MCA',
          hyomyung: 'HYOMYUNG',
          harrysYoungIl: 'Harrys Pack Jaya & Young IL'
        },
        hyomyungOption: {
          title: 'HYOMYUNG 옵션 선택',
          option1: '옵션 1 - 기본',
          option2: '옵션 2 - 축소'
        },
        description: {
          line1: '선택한 템플릿으로 컨펌 카드를 인쇄합니다.',
          line2: '한 페이지에 최대 10개 항목까지 표시됩니다.'
        },
        orderAdjustment: '인쇄 순서',
        totalItems: '총 {{count}}개',
        orderInstruction: '드래그하거나 화살표 버튼을 사용하여 순서를 조정하세요.',
        additionalText: {
          placeholder: '추가 문구',
          options: {
            first: '(1ST)',
            second: '(2ND)',
            third: '(3RD)',
            fourth: '(4TH)',
            fifth: '(5TH)',
            sample: '(SAMPLE)',
            bulk: '(BULK)'
          }
        },
        search: {
          placeholder: 'Dyeing No, Style',
          button: '검색',
          add: '추가',
          added: '추가됨',
          addAll: '전체 추가',
          noResult: '검색 결과가 없습니다.',
          resultCount: '검색 결과 {{count}}건'
        }
      }
    },
    dialogs: {
      confirmTitle: '확인',
      confirmMessage: '수정사항을 등록 하시겠습니까?'
    },
    notification: {
      autoCloseIn: '{{seconds}}초 후 자동으로 닫힙니다',
      closing: '닫는 중...'
    },
    deleteDialog: {
      title: '항목 삭제 확인',
      message: '이 항목을 삭제하시겠습니까?이 작업은 되돌릴 수 없습니다.'
    },
    machineAssigned: '기계가 성공적으로 배정되었습니다',
    machineUnassigned: '기계가 성공적으로 해제되었습니다'
  },

  winding: {
    title: '와인딩 작업',
    qtyEditHint: '클릭하여 라벨 수량 변경',
    tabs: {
      batchRequest: '일괄 요청',
      requestStatus: '요청 현황',
      status: '현황',
      inventory: '재고 현황'
    },
    requestTitle: '와인딩 요청',
    assignWork: '작업 요청',
    columns: {
      no: 'No',
      date: 'DATE',
      styleNo: 'STYLE',
      subOrderId: 'SubOrderID',
      customer: 'CUSTOMER',
      customerName: '고객사명',
      productionNo: 'PRODUCTION NO',
      windingId: 'WINDING NO',
      wdQty: 'QTY',
      urgent: 'URGENT',
      remark: 'MISC',
      targetDate: 'TARGET DATE',
      dyeingNo: 'DYEING NO',
      windingNo: 'WINDING NO',
      item: 'ITEM',
      size: 'SIZE',
      qty: 'QTY',
      color: 'COLOR',
      cheezRackCode: 'LOC',
      workProcess: 'WORK PROCESS',
      vendor: 'VENDOR',
      dryingRequired: 'DRYING',
      factory: 'FACTORY',
      cheese: 'CHEESE',
      workType: '작업 타입',
      confirmationType: '컨펌 여부',
      stockType: '스톡 여부',
      operation: 'OPERATION',
      planDate: 'PLAN DATE',
      delivery: 'DELIVERY',
      rackCode: 'RACK CODE'
    },
    summary: {
      producedQty: '생산 QTY'
    },
    status: {
      waiting: '대기',
      inProgress: '진행중',
      drying: '건조',
      completed: '완료',
      cancelled: '취소'
    },
    operation: {
      waiting: '대기',
      processing: '진행중',
      drying: '건조',
      deliveryWaiting: '배송 대기',
      deliveryProcessing: '배송 진행',
      completed: '완료',
      editStartEndTitle: 'WINDING MODIFICATION',
      editStartEndTooltip: 'WINDING MODIFICATION'
    },
    messages: {
      requestSuccess: '요청이 성공적으로 처리되었습니다',
      requestFail: '요청 처리 중 오류가 발생했습니다',
      noNewItems: '요청할 새 항목이 없습니다',
      deleteFail: '와인딩 작업 삭제에 실패했습니다.',
      selectedItemsCount: '{{count}}개 항목 선택됨',
      noItemsSelected: '선택된 항목 없음',
      noPrintableItems: '인쇄 가능한 항목이 없습니다',
      quantityChangeSuccess: '작업 수량이 성공적으로 업데이트되었습니다.',
      quantityChangeFailed: '작업 수량 업데이트에 실패했습니다.',
      createSuccess: '와인딩 작업이 성공적으로 생성되었습니다',
      createFailed: '와인딩 작업 생성에 실패했습니다',
      updateSuccess: '와인딩 작업이 성공적으로 수정되었습니다',
      updateFailed: '와인딩 작업 수정에 실패했습니다',
      editSuccess: '와인딩 작업이 성공적으로 수정되었습니다',
      deleteSuccess: '와인딩 작업이 성공적으로 삭제되었습니다',
      deleteFailed: '와인딩 작업 삭제에 실패했습니다',
      saveSuccess: '변경사항이 성공적으로 저장되었습니다',
      saveFailed: '변경사항 저장에 실패했습니다',
      noChanges: '변경된 내용이 없습니다',
      invalidQuantity: '잘못된 수량입니다',
      insufficientQuantity: '잔여 수량이 부족합니다',
      selectItems: '항목을 선택해주세요',
      selectItemsToCreate: '생성할 항목을 선택해주세요',
      selectItemsToEdit: '수정할 항목을 선택해주세요',
      selectItemsToDelete: '삭제할 항목을 선택해주세요',
      selectItemsToPrint: '인쇄할 항목을 선택해주세요',
      confirmDelete: '선택한 항목을 삭제하시겠습니까?',
      confirmSave: '변경사항을 저장하시겠습니까?',
      cannotDeleteCompleted: '완료된 작업은 삭제할 수 없습니다',
      cannotEditCompleted: '완료된 작업은 수정할 수 없습니다',
      cannotDeleteInProgress: '진행 중인 작업은 삭제할 수 없습니다',
      cannotEditInProgress: '진행 중인 작업은 수정할 수 없습니다',
      batchCreateSuccess: '{{count}}개 항목이 성공적으로 생성되었습니다',
      batchUpdateSuccess: '{{count}}개 항목이 성공적으로 수정되었습니다',
      batchDeleteSuccess: '{{count}}개 항목이 성공적으로 삭제되었습니다',
      batchCreateFailed: '일괄 생성에 실패했습니다',
      batchUpdateFailed: '일괄 수정에 실패했습니다',
      batchDeleteFailed: '일괄 삭제에 실패했습니다',
      validationError: '입력값을 확인해주세요',
      networkError: '네트워크 오류가 발생했습니다',
      serverError: '서버 오류가 발생했습니다',
      unauthorized: '권한이 없습니다',
      forbidden: '접근이 거부되었습니다',
      notFound: '요청한 데이터를 찾을 수 없습니다',
      timeout: '요청 시간이 초과되었습니다',
      unknownError: '알 수 없는 오류가 발생했습니다'
    },
    filter: {
      showAll: '전체 보기',
      showBeforeWinding: '와인딩 전',
      showProcessing: '와인딩 중',
      showCompleted: '와인딩 완료',
      showWindingOnly: '와인딩 번호 있음',
      showWithoutWinding: '와인딩 번호 없음'
    },
    schedule: {
      title: '스케줄 조정',
      adjustButton: '스케줄 조정',
      batchChange: '일괄 스케줄 변경',
      workOrder: '작업 목록',
      changeDate: '날짜 변경',
      noData: '데이터가 없습니다',
      updateFailed: '스케줄 업데이트에 실패했습니다',
      dateRangeError: '날짜 범위 오류',
      dateRangeErrorMessage: '선택하신 날짜는 검색 기간을 벗어났습니다.',
      dateRangeDetail: '검색 기간: {{startDate}} ~ {{endDate}}',
      dateRangeInstruction: '검색 기간 내의 날짜를 선택해 주시기 바랍니다.',
      saveFailed: '저장 실패',
      saveFailedMessage: '스케줄 변경사항 저장 중 오류가 발생했습니다.',
      saveFailedInstruction: '잠시 후 다시 시도해 주시기 바랍니다.',
      itemsSelected: '{{count}}개 선택'
    },
    tooltip: {
      toggleDrying: '건조',
      toggleUrgent: 'Urgent',
      toggleDryingOn: '모든 항목을 건조로 설정',
      toggleDryingOff: '모든 항목의 건조 해제',
      toggleUrgentOn: '모든 항목을 Urgent로 설정',
      toggleUrgentOff: '모든 항목의 Urgent 해제'
    },
    confirmDialog: {
      title: '확인',
      message: '와인딩 작업을 요청하시겠습니까?'
    },
    confirm: {
      titleWithCount: '와인딩 시작 확인 ({{count}})',
      message: '아래 항목들의 와인딩 작업을 시작하시겠습니까?'
    },
    fields: {
      searchConditions: '검색 조건'
    },
    status: {
      waiting: '대기',
      inProgress: '진행 중',
      drying: '건조',
      completed: '완료',
      cancelled: '취소'
    },
    monitoring: {
      filterStatus: '상태 필터',
      status: {
        all: '모든 항목',
        waiting: '대기',
        inProgress: '진행 중',
        drying: '건조',
        completed: '완료',
        cancelled: '취소'
      }
    },
    print: {
      selectedItemsCount: '{{count}}개 선택됨',
      noItemsSelected: '선택된 항목 없음',
      workOrderButton: '작업지시서',
      workOrderTitle: 'Winding Request',
      label: 'Label',
      shippingMark: 'Shipping Mark',
      labelDialog: {
        title: '라벨 인쇄',
        description: '{{count}}개 항목 선택 / 총 {{total}}장 인쇄',
        subOrderNo: '서브오더번호',
        printQty: '인쇄수량',
        remark: '비고',
        printButton: '인쇄',
        noItems: '인쇄 가능한 항목이 없습니다.'
      },
      workOrder: {
        title: '작업지시서',
        items: '개',
        totalItems: '총 {{count}}개 항목',
        targetDate: '타겟 날짜',
        workDate: '작업 날짜',
        planDate: '작업 날짜',
        cone: '콘',
        noTodayWork: '오늘 날짜에 진행되는 작업이 없습니다',
        orderInstruction: '작업 순서대로 표시됩니다',
        noDataMessage: '선택한 날짜에 작업 데이터가 없습니다',
        signature: '서명',
        date: '날짜',
        columns: {
          no: 'NO',
          windingNo: 'WINDING NO',
          dyeingNo: 'DYEING NO',
          styleNo: 'STYLE NO',
          vendor: 'VENDOR',
          factory: 'FACTORY',
          item: 'ITEM',
          color: 'COLOR',
          qty: 'QTY',
          size: 'SIZE',
          remark: 'REMARK'
        }
      },
      workOrderData: {
        title: '작업지시서',
        targetDate: '타겟 날짜',
        selectDate: '날짜 선택',
        totalItems: '총 {{count}}개 항목',
        items: '개',
        orderInstruction: '작업 순서대로 표시됩니다',
        totalQty: '총 수량',
        printDate: '인쇄일',
        preparedBy: '작성자',
        checkedBy: '검토자',
        approvedBy: '승인자',
        windingAdmin: 'Winding Admin',
        marketingLeader: 'Marketing Leader',
        windingLeader: 'Winding Leader',
        columns: {
          no: 'NO',
          windingNo: 'WINDING NO',
          dyeingNo: 'DYEING NO',
          styleNo: 'STYLE NO',
          buyer: 'BUYER',
          vendor: 'VENDOR',
          item: 'ITEM',
          color: 'COLOR',
          qty: 'QTY',
          size: 'SIZE',
          remark: 'REMARK'
        },
        dateChange: '날짜 변경',
        dateChangeSuccess: '날짜가 성공적으로 변경되었습니다',
        dateChangeFailed: '날짜 변경에 실패했습니다',
        selectDate: '날짜 선택'
      },
      printTrimCard: '트림 카드 인쇄',
      trimCard: {
        title: '트림 카드 인쇄 설정',
        selectedItems: '선택된 항목: {{count}}개',
        templateSelect: '템플릿 선택',
        includeBuyerDetail: '바이어 상세 포함',
        templates: {
          standard: 'STANDARD',
          saeA: 'SAE-A',
          ubase: 'UBASE',
          shinwon: 'SHINWON',
          hyomyung: 'HYOMYUNG',
          hansoll: 'HANSOLL'
        },
        hyomyungOption: {
          title: 'HYOMYUNG 옵션 선택',
          option1: '옵션 1 - 기본',
          option2: '옵션 2 - 축소'
        },
        description: {
          line1: '선택된 템플릿으로 트림 카드를 인쇄합니다.',
          line2: '페이지당 최대 10개 항목이 표시됩니다.'
        },
        orderAdjustment: '인쇄 순서 조정',
        totalItems: '총 {{count}}개 항목',
        orderInstruction: '드래그하거나 화살표 버튼으로 순서를 조정하세요.',
        additionalText: {
          placeholder: '추가 텍스트',
          options: {
            first: '(1ST)',
            second: '(2ND)',
            third: '(3RD)',
            fourth: '(4TH)',
            fifth: '(5TH)',
            sample: '(SAMPLE)',
            bulk: '(BULK)'
          }
        }
      }
    }
  },

  shipping: {
    title: '출고 작업',
    assignWork: '작업 요청',
    columns: {
      no: 'No',
      date: 'DATE',
      styleNo: 'STYLE',
      productionNo: 'PRODUCTION NO',
      shippingId: 'SHIPPING NO',
      shippingQty: 'QTY',
      urgent: 'URGENT',
      remark: 'REMARK',
      targetDate: 'DATE',
      dyeingNo: 'DYEING NO',
      buyer: 'BUYER',
      manager: 'MANAGER',
      vendor: 'VENDOR',
      fileNo: 'FILE NO',
      threadName: 'THREAD NAME',
      color: 'COLOR',
      size: 'SIZE',
      qty: 'QTY',
      shippingTargetDate: 'TARGET DATE',
      truckName: 'TRUCK',
      remark: 'REMARK',
      windingNo: 'WINDING NO',
      timeOfDeparture: 'DEPARTURE',
      timeOfArrival: 'ARRIVAL',
      ctNo: 'C/T NO',
      tracking: 'TRACKING'
    },
    filter: {
      showAll: '전체 보기',
      showShippingOnly: '출고일자 O',
      showWithoutShipping: '출고일자 X',
      showCompleted: '배송 완료',
      showInProgress: '배송 진행/대기'
    },
    fields: {
      searchConditions: '검색 조건'
    },
    tracking: {
      completed: '배송 완료',
      in_progress: '배송 중',
      not_started: '배송 대기'
    },
    selectedItemsCount: '{{count}}개 항목 선택됨',
    noItemsSelected: '선택된 항목 없음',
    printCustomsDocuments: '세관서류',
    printInvoice: '출고증',
    print: {
      noItemsSelectedForPrint: '인쇄할 항목을 선택해주세요.',
      noValidItemsSelected: '선택된 항목 중 유효한 데이터가 없습니다.',
      downloadSuccess: '엑셀 파일이 다운로드되었습니다.',
      downloadFailed: '파일 다운로드에 실패했습니다.',
      downloading: '파일 다운로드 중',
      downloadComplete: '다운로드 완료'
    },
    invoice: {
      print: '프린트',
      pdf: 'PDF',
      printPreview: '출고증',
      splitBy: '기준',
      splitByCustomer: '고객사',
      splitByManager: '담당자',
      to: '수신',
      documentNumber: '문서번호',
      apply: '적용',
      loading: '출고증을 준비중입니다'
    },
    dialog: {
      createShippingRequest: {
        title: '출고 요청',
        description: '선택된 {{count}}개 항목에 대한 출고 요청을 생성합니다.',
        submit: '출고 요청 생성'
      },
      editOperations: {
        title: '출고 작업',
        description: '선택된 {{count}}개 항목의 작업 정보를 수정합니다.',
        submit: '제출'
      },
      bulkSettings: {
        title: '일괄 설정',
        targetDate: '목표 출고일',
        truck: '트럭명',
        remark: '비고',
        departure: '출발시각',
        arrival: '도착시각',
        applyAll: '일괄 적용',
        apply: '적용',
        today: '오늘',
        now: '지금'
      },
      selectedItems: {
        title: '선택된 항목'
      },
      actions: {
        edit: '수정',
        save: '저장',
        cancel: '취소'
      }
    },
    editOperations: '작업 수정',
    customs: {
      selectDocument: '세관서류 선택',
      selectDocumentDescription: '출력할 세관서류 양식을 선택해주세요.',
      bc27: 'BC 27',
      bc25: 'BC 25',
      bc41: 'BC 41',
      bc30: 'BC 30',
      noItemsSelected: '세관서류를 출력할 항목을 선택해주세요.',
      loadingDocument: '세관서류 준비 중...',
      bc27Title: 'BC 27 - Commercial Invoice & Packing List',
      documentNumber: '문서번호',
      outputFormat: '출력 형식',
      exchangeRate: '환율',
      shipper: 'Shipper/Exportir',
      consignee: 'Consignee',
      notifyParty: 'Notify Party',
      invoiceNo: 'No. & Date of Invoice',
      lcNumber: 'No. & Date of L/C',
      remark: 'Remark',
      portOfLoading: 'Port of Loading',
      finalDestination: 'Final Destination',
      carrier: 'Carrier',
      sailingDate: 'Sailing on or about',
      marksNumber: 'Marks and Number of PKGS',
      itemCode: 'Kode Barang',
      hsCode: 'HS Code',
      style: 'Style',
      description: 'Description of goods',
      netKg: 'Net Kg',
      qty: 'Qty',
      totalPrice: 'Total Price',
      rate: 'Kurs',
      package: 'kemasan',
      amount: 'Amount (Rp)',
      doubleClickToEdit: '더블클릭하여 수정',
      npwp16: 'NPWP 16',
      nitku: 'NITKU',
      npwpPlaceholder: '00.000.000.0-000.000',
      nitkuPlaceholder: '0000000000000000000000',
      addressPlaceholder: '주소',
      cityPlaceholder: '도시',
      address1: '주소 1',
      address2: '주소 2',
      address1Placeholder: '주소 1',
      address2Placeholder: '주소 2',
      loadingCustomsDocuments: '세관 서류 데이터를 준비하는 중입니다...',
      vendorInfoWarning: '주 데이터 > 거래처 > 거래처 등록 에서 Address, NPWP, NITKU를 확인해주세요.'
    }
  },

  dashboard: {
    activeOrders: '진행중인 오더',
    productionRate: '생산 진행률',
    pendingShipments: '출고 대기',
    averageProcessTime: '평균 처리시간',
    thisMonthOrders: '이번 달 주문',
    lastMonthOrders: '지난 달 주문',
    thisMonthShipments: '이번 달 출하',
    lastMonthShipments: '지난 달 출하',
    recentProduction: '최근 생산 현황',
    orderStatus: '오더 현황',
    inbound: '입고',
    outbound: '출고',
    vsLastWeek: '전주 대비',
    vsTarget: '목표 대비',
    vsYesterday: '전일 대비',
    vsLastMonth: '전월 대비',
    vsLastYear: '전년 대비',
    currentMonth: '현재 월',
    date: '날짜',
    noProductionData: '생산 데이터가 없습니다',
    production: {
      winding: '와인딩',
      windingStatus: '와인딩 생산 현황',
      cheese: '치즈',
      batch: 'LOT',
      batch_s1: 'LOT 1S (06–14)',
      batch_s2: 'LOT 2S (14–22)',
      batch_s3: 'LOT 3S (22–06)',
      dyeing: '염색 생산현황',
      dyeingDayBasis: '염색 운영일: {{timezone}} {{hour}}:00 기준'
    }
  },

  login: {
    welcome: '환영합니다',
    username: '아이디',
    password: '비밀번호',
    rememberMe: '아이디 저장',
    forgotPassword: '비밀번호 찾기',
    login: '로그인',
    noAccount: '계정이 없으신가요?',
    signup: '회원가입',
    loading: '로그인 중...',
    success: '로그인 성공',
    validation: {
      required: '아이디와 비밀번호를 모두 입력해주세요.',
      usernameRequired: '아이디를 입력해주세요.',
      passwordRequired: '비밀번호를 입력해주세요.'
    },
    error: {
      notFound: '존재하지 않는 계정입니다.\n아이디를 확인해주세요.',
      invalidPassword: '잘못된 비밀번호입니다.\n다시 시도해주세요.',
      waitingApproval: '관리자의 승인을 기다려주세요.',
      blocked: '차단된 계정입니다.\n관리자에게 문의해주세요.',
      network: '네트워크 오류가 발생했습니다.\n연결을 확인해주세요.',
      unknown: '알 수 없는 오류가 발생했습니다.\n다시 시도해주세요.',
      userFetchFailed: '사용자 정보 조회 중 오류가 발생했습니다.',
      userUpdateFailed: '사용자 정보 수정 중 오류가 발생했습니다.',
      languageUpdateFailed: '언어 설정 변경 중 오류가 발생했습니다.',
      logoutFailed: '로그아웃 처리 중 오류가 발생했습니다.'
    }
  },

  signup: {
    title: '회원가입',
    department: '부서',
    region: '지역',
    fullName: '성명',
    userId: '아이디',
    password: '비밀번호',
    confirmPassword: '비밀번호 확인',
    submit: '가입하기',
    loading: '계정 생성 중...',
    cancel: '취소',
    submitting: '저장 중...',
    messages: {
      registerSuccess: '계정이 성공적으로 생성되었습니다.\n관리자 승인을 기다려주세요.'
    },
    validation: {
      required: '필수 입력 항목입니다',
      fullName: {
        invalid: '성명은 한글, 영문자, 공백만 입력 가능합니다'
      },
      userId: {
        tooShort: '아이디는 최소 6자 이상이어야 합니다',
        invalid: '아이디는 영문 대/소문자와 숫자만 입력 가능합니다'
      },
      password: {
        tooShort: '비밀번호는 최소 6자 이상이어야 합니다',
        invalid: '비밀번호는 대문자, 소문자, 숫자, 특수문자를 각각 1개 이상 포함해야 합니다'
      },
      passwordMismatch: '비밀번호가 일치하지 않습니다'
    },
    error: {
      duplicate: '이미 사용 중인 아이디입니다.\n다른 아이디를 시도해주세요.',
      network: '네트워크 오류가 발생했습니다.\n다시 시도해주세요.',
      unknown: '알 수 없는 오류가 발생했습니다.\n다시 시도해주세요.',
      userIdExists: '이미 사용 중인 아이디입니다.',
      initialStrExists: '이미 사용 중인 이니셜입니다.',
      passwordInvalid: '비밀번호가 유효하지 않습니다.',
      requiredFields: '필수 항목을 모두 입력해주세요.',
      passwordMismatch: '비밀번호가 일치하지 않습니다.',
      passwordLength: '비밀번호는 최소 6자 이상이어야 합니다.',
      userIdRequired: '아이디를 입력해주세요.',
      passwordRequired: '비밀번호를 입력해주세요.',
      confirmPasswordRequired: '비밀번호 확인을 입력해주세요.',
      fullNameRequired: '성명을 입력해주세요.',
      departmentRequired: '부서를 선택해주세요.',
      regionRequired: '지역을 선택해주세요.',
      initialStrRequired: '이니셜을 입력해주세요.',
      server: '서버 오류가 발생했습니다. 다시 시도해주세요.'
    },
    fields: {
      userId: '아이디',
      password: '비밀번호',
      confirmPassword: '비밀번호 확인',
      fullName: '성명',
      department: '부서',
      region: '지역',
      initialStr: '이니셜',
      initialStrHelp: '영문 성명의 첫 알파벳입니다. 하나 또는 두 알파벳만 입력 가능합니다.'
    },
    regions: {
      korea: '한국',
      vietnam: '베트남',
      indonesia: '인도네시아'
    },
    departments: {
      marketing: '마케팅',
      dyeing: '염색부',
      production: '생산부',
      'qc/qa': 'QC/QA',
      admin: '관리자'
    }
  },

  companies: {
    tabs: {
      company: '거래처 등록',
      manager: '담당자 등록',
      factory: '입고처 등록',
      map: '입고처 지도'
    },
    companyInfo: '거래처 정보',
    fields: {
      partner_code: '거래처 코드',
      companyName: '거래처명',
      businessNumber: '사업자등록번호',
      representative: '대표자명',
      businessType: '업종',
      businessCategory: '업태',
      postalCode: '우편번호',
      baseAddress: '기본주소',
      detailAddress: '상세주소',
      address: '주소',
      extraInfo: '추가 정보',
      extraInfoKey: '키',
      extraInfoValue: '값',
      addExtraInfo: '추가 정보 추가',
      created_at: '등록시간',
      created_by: '등록자',
      searchByNameOrCode: '거래처코드 또는 거래처명으로 검색',
      searchByPartnerCodeOrCompanyName: '파트너 코드 또는 회사명으로 검색'
    },
    list: {
      title: '거래처 목록'
    },
    search: '고객사 검색',
    addressSearch: '주소 검색',
    searchPlaceholder: '거래처명 또는 사업자번호로 검색',
    add: {
      title: '거래처 등록',
      confirmMessage: '새로운 거래처를 등록하시겠습니까?',
      success: '거래처가 등록되었습니다.'
    },
    edit: {
      title: '거래처 수정',
      success: '거래처 정보가 수정되었습니다.',
      confirmMessage: '거래처 정보를 수정하시겠습니까?'
    },
    delete: {
      title: '거래처 삭제',
      confirmMessage: '{{name}}을(를) 삭제하시겠습니까?'
    },
    changes: {
      before: '이전',
      after: '이후'
    }
  },

  buyers: {
    title: '바이어 관리',
    form: {
      title: '바이어 정보'
    },
    list: {
      title: '바이어 목록'
    },
    fields: {
      buyerCode: '바이어코드',
      buyerName: '바이어명',
      buyerGroup: '그룹',
      category: '카테고리',
      remark: '비고'
    },
    validation: {
      required: '필수 입력 항목입니다',
      duplicateCategoryBuyer: '동일한 카테고리와 바이어명이 이미 존재합니다'
    },
    add: {
      title: '바이어 등록',
      confirmMessage: '새로운 바이어를 등록하시겠습니까?',
      success: '바이어가 등록되었습니다.'
    },
    edit: {
      title: '바이어 수정',
      confirmMessage: '바이어 정보를 수정하시겠습니까?',
      success: '바이어 정보가 수정되었습니다.'
    },
    delete: {
      title: '바이어 삭제',
      confirmMessage: '{{name}}을(를) 삭제하시겠습니까?'
    },
    searchPlaceholder: '바이어코드 또는 바이어명으로 검색',
    error: {
      duplicateCategoryBuyer: '동일한 카테고리와 바이어명이 이미 존재합니다'
    }
  },

  managers: {
    form: {
      title: '담당자 정보'
    },
    fields: {
      name: '담당자명',
      partnerId: '거래처명',
      telephone: '전화번호',
      mobile: '휴대전화',
      fax: '팩스번호',
      email: '이메일',
      partnerName: '거래처명'
    },
    list: {
      title: '담당자 목록'
    },
    add: {
      title: '담당자 등록',
      confirmMessage: '새로운 담당자를 등록하시겠습니까?',
      success: '담당자가 등록되었습니다.'
    },
    edit: {
      title: '담당자 수정',
      success: '담당자 정보가 수정되었습니다.',
      confirmMessage: '담당자 정보를 수정하시겠습니까?'
    },
    delete: {
      title: '담당자 삭제',
      confirmMessage: '{{name}}을(를) 삭제하시겠습니까?'
    },
    searchPlaceholder: '담당자명 또는 거래처명으로 검색',
    validation: {
      selectCompany: '거래처를 선택해주세요'
    },
    error: {
      title: "오류",
      save: "저장에 실패했습니다.",
      duplicateManager: "이미 등록된 담당자명 입니다."
    }
  },

  factories: {
    form: {
      title: '입고처 정보'
    },
    list: {
      title: '입고처 목록'
    },
    fields: {
      partner: '거래처명',
      name: '입고처명',
      shippingMark: '쉬핑마크',
      region: '지역',
      address: '주소',
      address1: '주소 1',
      address2: '주소 2',
      city: '도시',
      state: '주/도',
      postcode: '우편번호',
      country: '국가',
      countryCode: '국가코드',
      taxId: '사업자등록번호',
      customsId: '수출입업 고유번호',
      extraInfo: '추가 정보',
      extraInfoKey: '키',
      extraInfoValue: '값',
      addPartner: '거래처 추가',
      addExtraInfo: '추가 정보 추가'
    },
    validation: {
      selectCompany: '거래처를 선택해주세요',
      required: '필수 입력 항목입니다'
    },
    add: {
      title: '입고처 등록',
      confirmMessage: '새로운 입고처를 등록하시겠습니까?',
      success: '입고처가 등록되었습니다.'
    },
    edit: {
      title: '입고처 수정',
      confirmMessage: '입고처 정보를 수정하시겠습니까?',
      success: '입고처가 수정되었습니다.'
    },
    delete: {
      title: '입고처 삭제',
      confirmMessage: '{{name}}을(를) 삭제하시겠습니까?'
    },
    searchPlaceholder: '거래처명 또는 입고처명으로 검색'
  },

  admin: {
    registration: {
      list: '회원가입 목록',
      userId: '아이디',
      name: '이름',
      department: '부서',
      region: '지역',
      date: '등록일',
      actions: '작업',
      status: {
        pending: '대기중',
        approved: '승인됨',
        rejected: '거부됨',
        all: '전체 상태'
      },
      approve: '승인',
      reject: '거부',
      add: '등록 추가',
      addNew: '신규 등록 추가',
      addSuccess: '사용자가 성공적으로 추가되었습니다.',
      allDepartments: '전체 부서',
      status_name: '상태',
      approveSuccess: '가입 승인이 되었습니다.',
      approveFailed: '가입 승인이 실패 했습니다.',
      rejectSuccess: '가입이 거부 되었습니다.',
      rejectFailed: '가입 거부를 실패 했습니다.'
    },
    passwordReset: {
      list: '비밀번호 재설정 목록',
      userId: '아이디',
      name: '이름',
      department: '부서',
      region: '지역',
      lastReset: '최근 재설정',
      resetButton: '비밀번호 재설정',
      confirmReset: '비밀번호를 재설정하시겠습니까?',
      action: '작업'
    },
    accessLogs: {
      list: '접속 로그',
      userId: '아이디',
      name: '이름',
      department: '부서',
      accessTime: '접속 시간',
      ipAddress: 'IP 주소',
      action: '작업',
      status: '상태',
      allDepartments: '전체 부서',
      region: '지역',
      departments: {
        all: '전체 부서',
        production: '생산',
        marketing: '마케팅',
        admin: '관리자'
      },
      actions: {
        login: '로그인',
        logout: '로그아웃',
        all: '전체 작업'
      },
      status: {
        name: '상태',
        success: '성공',
        failed: '실패'
      }
    },
    message: {
      title: '메시지 제목',
      content: '메시지 내용',
      send: '메시지 보내기',
      selectedUsers: '선택된 사용자',
      user: '사용자',
      selectUsers: '사용자 선택',
      department: '부서',
      region: '지역',
      allDepartments: '전체 부서',
      departments: {
        production: '생산',
        marketing: '마케팅',
        admin: '관리자'
      }
    },
    threads: {
      tabs: {
        item: '아이템 등록',
        weight: '중량 등록'
      },
      list: {
        title: '아이템 목록'
      },
      form: {
        title: '아이템 정보'
      },
      edit: {
        title: '아이템 수정',
        confirmMessage: '아이템을 수정하시겠습니까?',
        success: '아이템이 수정되었습니다.'
      },
      fields: {
        threadName: '아이템명',
        specification: '원사 종류',
        division: '구분',
        yarn_type: '원사 종류',
        tex: 'TEX',
        ne: 'NE',
        denier: 'DENIER',
        thread_luster_type: '실 광택 타입',
        threadLusterType: '실 광택 타입',
        recycleCode: '친환경 코드',
        weight: '중량',
        unit: '단위'
      },
      searchPlaceholder: '아이템명으로 검색',
      validation: {
        required: '필수 입력 항목입니다',
        invalidNumber: '유효한 숫자를 입력해주세요',
        duplicateSpecification: '이미 등록된 아이템 규격입니다',
        duplicateThread: '동일한 아이템 규격의 데이터가 이미 존재합니다',
        unit: '단위를 입력해주세요',
        selectItem: '아이템을 선택해주세요'
      },
      add: {
        title: '아이템 등록',
        confirmMessage: '새로운 아이템을 등록하시겠습니까?',
        success: '아이템이 등록되었습니다.'
      },
      delete: {
        title: '아이템 삭제',
        confirmMessage: '{{name}}을(를) 삭제하시겠습니까?'
      }
    },
    prices: {
      list: {
        title: '단가 목록',
        totalCount: '총 단가 항목 : {{count}}개'
      },
      columns: {
        no: 'NO',
        customer: '거래처',
        item: '아이템',
        size: '길이',
        currency: '화폐',
        price: '단가',
        spec: '비고',
        regDate: '등록일',
        action: '관리'
      },
      picker: {
        title: '검색 결과 선택',
        type: '구분',
        name: '이름',
        customer: '거래처',
        item: '아이템'
      },
      form: {
        title: '단가 정보'
      },
      fields: {
        companyName: '거래처명',
        itemName: '아이템명',
        size: '길이(M)',
        currency: '화폐',
        price: '단가',
        searchByNameOrCode: '거래처명 또는 아이템명으로 검색',
        duplicate: '이미 등록된 단가 입니다.'
      },
      validation: {
        required: '필수 입력 항목입니다'
      },
      add: {
        title: '단가 등록',
        confirmMessage: '새로운 단가를 등록하시겠습니까?',
        success: '단가가 등록되었습니다.'
      },
      edit: {
        title: '단가 수정',
        confirmMessage: '단가 정보를 수정하시겠습니까?',
        success: '단가가 수정되었습니다.'
      },
      delete: {
        title: '단가 삭제',
        confirmMessage: '해당 단가를 삭제하시겠습니까?',
        success: '단가가 삭제되었습니다.'
      },
      searchPlaceholder: '거래처명 또는 아이템명으로 검색'
    },
    sizes: {
      list: {
        title: '길이 목록'
      },
      form: {
        title: '길이 정보'
      },
      fields: {
        size: '길이(M)'
      },
      validation: {
        required: '필수 입력 항목입니다',
        invalidNumber: '유효한 숫자를 입력해주세요',
        duplicate: '이미 등록된 길이입니다.',
        selectSize: '길이를 선택해주세요'
      },
      add: {
        title: '길이 등록',
        confirmMessage: '새로운 길이를 등록하시겠습니까?',
        success: '길이가 등록되었습니다.'
      },
      edit: {
        title: '길이 수정',
        confirmMessage: '길이 정보를 수정하시겠습니까?',
        success: '길이가 수정되었습니다.'
      },
      delete: {
        title: '길이 삭제',
        confirmMessage: '{{name}} 길이를 삭제하시겠습니까?'
      },
      searchPlaceholder: '길이로 검색',
      search: '길이 검색'
    },
    weights: {
      list: {
        title: '중량 목록'
      },
      form: {
        title: '중량 정보'
      },
      fields: {
        threadName: '아이템명',
        size: '길이(M)',
        netWeight: '순중량 (N/W)',
        grossWeight: '총중량 (G/W)',
        ctQuantity: '수량 (C/T)',
        remark: '비고'
      },
      validation: {
        required: '필수 입력 항목입니다',
        invalidNumber: '유효한 숫자를 입력해주세요',
        duplicate: '이미 등록된 중량 구성입니다.'
      },
      add: {
        title: '중량 등록',
        confirmMessage: '새로운 중량을 등록하시겠습니까?',
        success: '중량이 등록되었습니다.'
      },
      edit: {
        title: '중량 수정',
        confirmMessage: '중량 정보를 수정하시겠습니까?',
        success: '중량이 수정되었습니다.'
      },
      delete: {
        title: '중량 삭제',
        confirmMessage: '이 중량을 삭제하시겠습니까?'
      },
      searchPlaceholder: '아이템명으로 검색',
      search: '중량 검색'
    },
    yarn: {
      list: '원사 목록',
      code: '원사 코드',
      type: '유형',
      count: '번수',
      twist: '꼬임',
      supplier: '공급사',
      lotNumber: '로트번호',
      quantity: '수량',
      location: '위치',
      status: {
        inStock: '재고있음',
        lowStock: '재고부족',
        outOfStock: '재고없음',
        all: '전체 상태'
      },
      add: '원사 추가',
      addNew: '신규 원사 추가',
      allTypes: '전체 유형',
      type: {
        cotton: '면사',
        polyester: '폴리에스터',
        blend: '혼방사'
      },
      location: {
        warehouseA: '창고 A',
        warehouseB: '창고 B',
        production: '생산'
      },
      showHistory: '이력 보기',
      history: '이동 이력'
    },
    dye: {
      list: '염료 목록',
      code: '염료 코드',
      name: '염료명',
      type: '유형',
      manufacturer: '제조사',
      color: '컬러명',
      lotNumber: '로트번호',
      quantity: '수량',
      location: '위치',
      expiryDate: '유효기간',
      status: {
        inStock: '재고있음',
        lowStock: '재고부족',
        outOfStock: '재고없음',
        expired: '기간만료',
        nearExpiry: '만료임박',
        all: '전체 상태'
      },
      add: '염료 추가',
      addNew: '신규 염료 추가',
      allTypes: '전체 유형',
      type: {
        reactive: '반응성',
        disperse: '분산성',
        acid: '산성'
      },
      color: {
        blue: '청색',
        red: '적색',
        yellow: '황색'
      },
      location: {
        storageA: '보관소 A',
        storageB: '보관소 B',
        production: '생산'
      },
      showHistory: '이력 보기',
      history: '이동 이력',
      expiredWarning: '유효기간이 만료된 제품입니다',
      sampleName: '샘플 염료'
    },
    inventory: {
      list: '재고 목록',
      code: '품목 코드',
      name: '품목명',
      type: '유형',
      category: '분류',
      quantity: '수량',
      location: '위치',
      minStock: '최소 재고',
      maxStock: '최대 재고',
      lastMovement: '최근 이동',
      stockRange: '재고 범위',
      status: {
        inStock: '재고있음',
        lowStock: '재고부족',
        overStock: '재고초과',
        all: '전체 상태'
      },
      add: '재고 추가',
      addNew: '신규 재고 추가',
      allTypes: '전체 유형',
      allLocations: '전체 위치',
      type: {
        yarn: '원사',
        dye: '염료',
        chemical: '화공약품',
        packaging: '포장재'
      },
      category: {
        rawMaterial: '원자재',
        finishedGood: '완제품',
        packaging: '포장재'
      },
      location: {
        warehouseA: '창고 A',
        warehouseB: '창고 B',
        production: '생산'
      },
      recordMovement: '이동 기록',
      sampleItem: '샘플 품목'
    },
    bi: {
      title: 'BI',
      startDate: '시작일',
      endDate: '종료일',
      customer: '업체명',
      manager: '담당자',
      buyer: '바이어',
      search: '검색',
      loading: '잠시만 기다려주세요...',
      orderDate: '접수일',
      vendorName: '업체명',
      itemName: '아이템',
      size: '사이즈',
      color: '컬러',
      qty: '수량',
      price: '단가',
      amount: '금액',
      total: '합계',
      itemAggregationTitle: '기간별 아이템 집계',
      noData: '데이터가 없습니다',
      searchGuide: '검색하여 데이터를 확인하세요',
      error: '오류',
      dateError: '종료일이 시작일보다 빠를 수 없습니다.'
    }
  },

  error: {
    fetch: '데이터를 불러오는데 실패했습니다',
    network: '네트워크 오류가 발생했습니다',
    unknown: '알 수 없는 오류가 발생했습니다',
    title: '오류',
    duplicate: '이미 등록된 거래처입니다',
    duplicateFactory: '이미 등록된 입고처입니다',
    duplicateManager: '이미 등록된 담당자입니다',
    duplicateDivisionSeason: '이미 등록된 바이어 구분/시즌 입니다.',
    save: '저장에 실패했습니다',
    unauthorized: '로그인 토큰이 만료되었습니다.\n다시 로그인을 해주세요.',
    noChanges: '수정된 내용이 없습니다',
    sessionExpired: '세션이 만료되었습니다. 다시 로그인해 주세요.'
  },

  initialStr: {
    label: '염색 고유 코드',
    placeholder: '1-2자리 영문 입력 (a-z, A-Z)',
    required: '염색 고유 코드를 입력해주세요',
    invalid: '영문 1-2자리만 입력 가능합니다',
    alreadyExists: '이미 사용중인 고유 코드 입니다',
    validationFailed: '고유 코드 검증에 실패했습니다',
    notVerified: '염색 고유 코드의 중복 여부를 확인해 주십시오',
    verifying: '고유 코드 확인 중...'
  },

  validation: {
    required: '필수 입력 항목입니다',
    selectCompany: '거래처를 선택해주세요'
  },

  warning: {
    title: '경고'
  },
  
  userInfoDialog: {
    title: '사용자 정보',
    basicInfo: '기본 정보',
    id: 'ID (읽기전용)',
    name: '이름',
    department: '부서 (읽기전용)',
    region: '지역',
    password: '비밀번호',
    editableInfo: '수정 가능 정보',
    passwordChange: '비밀번호 변경',
    newPassword: '신규 비밀번호',
    confirmNewPassword: '신규 비밀번호 확인',
    currentPassword: '현재 비밀번호',
    confirmCurrentPassword: '현재 비밀번호 확인',
    passwordError: '비밀번호가 일치하지 않습니다',
    passwordSuccess: '비밀번호가 성공적으로 변경되었습니다',
    theme: '테마',
    color: '색상',
    themeDefault: '기본',
    themeLight: '라이트',
    themeDark: '다크',
    themeAuto: '자동',
    colorDefault: '기본',
    colorBlue: '파란색',
    colorGreen: '초록색',
    colorPurple: '보라색',
    colorOrange: '주황색',
    colorRed: '빨간색',
    colorTeal: '청록색',
    colorPink: '분홍색',
    colorIndigo: '남색',
    colorAmber: '호박색',
    colorCyan: '시안',
    colorBrown: '갈색',
  },

  invoice: {
    title: '인보이스 발급',
    selectedItems: '선택된 항목',
    issueButton: '인보이스 발급',
    debitNoteButton: '거래 내역서 발급',
    debitNote: {
      errorTitle: '발급 불가',
      differentCustomers: '같은 거래처 항목만 선택해주세요',
      currentlySelectedCustomers: '현재 선택 된 거래처',
      missingPacking: '출고된 항목만 선택해주세요.',
      itemsWithoutPackingDate: 'PACKING 날짜가 없는 항목'
    },
    hideInvoicedToggle: {
      tooltipOff: '전체 행 표시',
      tooltipOn:
        '인보이스 번호가 있어도 ORDER QTY 대비 발급 수량 합이 부족한 행(부분 발급)은 계속 표시'
    },
    warning: '경고',
    selectItems: '발급할 항목을 선택해주세요',
    differentVendors: '선택된 항목들의 거래처가 서로 다릅니다. 같은 거래처의 항목만 선택해주세요.',
    differentCurrencies: '선택된 항목들의 통화가 서로 다릅니다. 같은 통화의 항목만 선택해주세요.',
    existingInvoiceWarning: '선택된 항목 중 {{existingCount}}/{{totalCount}}개는 이미 인보이스가 발행되었습니다. 계속 진행하시겠습니까?',
    issuanceSuccess: '인보이스가 성공적으로 발급되었습니다',
    partialIssuanceSuccess: '개의 인보이스가 성공적으로 발급되었습니다',
    issuanceError: '인보이스 발급에 실패했습니다',
    customerName: '고객사명',
    managerName: '담당자명',
    invoiceNo: '인보이스 번호',
    invoiceDate: '인보이스 날짜',
    dueDate: '만기일',
    currency: '통화',
    amount: '금액',
    vatAmount: 'VAT',
    vatAmount2: 'VAT2',
    totalAmount: '총액',
    status: '상태',
    updateStatus: '상태 변경',
    statusUpdateTitle: '인보이스 상태 변경',
    newStatus: '새로운 상태',
    selectedInvoices: '선택된 인보이스 ({{count}}개)',
    noData: '조회된 데이터가 없습니다',
    error: {
      selectItemsForStatusUpdate: '상태를 변경할 항목을 선택해주세요',
      selectItemsForPrint: '프린트할 인보이스를 선택해주세요',
      statusUpdateFailed: '상태 변경에 실패했습니다',
      noDataToExport: '내보낼 데이터가 없습니다',
      exportFailed: '내보내기 중 오류가 발생했습니다',
      noItemSelected: '선택된 항목이 없습니다'
    },
    print: {
      title: '인보이스 출력',
      preview: '인보이스 미리보기',
      columnSettings: '인쇄 컬럼 설정'
    },
    itemDetails: '아이템 상세',
    bankInfo: '은행 정보',
    success: {
      statusUpdate: '{{success}}개의 인보이스 상태가 성공적으로 변경되었습니다. (실패: {{fail}}개)',
      exportCompleted: '데이터가 성공적으로 내보내졌습니다'
    },
    statusOptions: {
      issued: '발급됨',
      pending: '대기중',
      cancelled: '취소됨',
      paid: '입금 완료',
      partial_paid: '부분 입금',
      partial: '부분 입금',
      canceled: '인보이스 취소',
      completed: '인보이스 완료',
      overdue: '만기 지연',
      canceled: '인보이스 취소',
      unpaid: '미입금'
    },
    vat: {
      taxFree: '면세',
      BC21: 'BC21',
      BC45: 'BC45'
    },
    columns: {
      no: 'NO',
      giReqNo: 'GI REQ NO',
      giReqLineId: 'GI REQ LINE ID',
      customer: 'CUSTOMER',
      subOrderId: 'SubOrderID',
      buyer: 'BUYER',
      style: 'STYLE',
      file: 'FILE',
      delivery: 'DELIVERY',
      manager: 'MANAGER',
      item: 'ITEM',
      size: 'SIZE',
      dyeingNo: 'DYEING NO',
      orderQty: 'ORDER QTY',
      giReq: 'GI REQ',
      packing: 'PACKING',
      giPost: 'GI POST',
      priceSum: 'PRICE SUM',
      invoiceNoCol: 'INVOICE NO',
      status: 'STATUS',
      currency: 'CURRENCY',
      mainOrderId: '메인 오더 ID',
      orderReceivedDate: '오더 접수일',
      deliveryDate: '납품일',
      vendorName: '거래처명',
      managerName: '담당자명',
      threadName: '원사명',
      sizeName: '사이즈',
      color: 'COLOR',
      giHistory: '납품 일자',
      qtyDelivered: '납품 수량',
      price: 'PRICE',
      priceCurrency: '통화',
      amount: '금액',
      existingInvoiceNo: '기존 인보이스 번호',
      existingInvoiceStatus: '기존 인보이스 상태',
      payment: '결제',
      paymentStatus: '결제상태',
      styleNo: '스타일 번호',
      fileNo: '파일 번호',
      factory: '공장',
      sign: '서명'
    },
    fields: {
      searchConditions: '검색 조건',
      deliveryId: 'DELIVERY ID'
    },
    minAmount: '최소 금액',
    maxAmount: '최대 금액',
    paymentStatus: '결제 상태',
    dialog: {
      title: '인보이스 발급 확인',
      description: '선택하신 항목들에 대해 인보이스를 발급하시겠습니까?',
      selectedCount: '선택된 항목',
      totalAmount: 'TOTAL',
      totalQuantity: 'QTY TOTAL',
      vendorName: '거래처명',
      summary: '요약 정보',
      itemCount: '항목 수',
      currencyAmount: 'TOTAL',
      details: '상세 정보',
      invoiceGroup: '인보이스 그룹',
      vatSelection: 'VAT 선택',
      vatType: 'VAT 유형',
      warning: '인보이스 발급 후에는 수정이 불가능합니다. 신중하게 확인해주세요.',
      confirm: '발급 확인',
      bulkApplyDeliveryDate: '선택 행에 일괄 적용',
      confirmTitle: '인보이스 발급 확인',
      confirmMessage: '발급된 인보이스는 취소할 수 없습니다.\n계속 진행하시겠습니까?',
      confirmYes: '예',
      confirmNo: '아니오'
    },
    row: {
      issued: '발급완료'
    }
  },
  master: {
    machine: {
      list: {
        title: '기계 목록'
      },
      form: {
        title: '기계 정보'
      },
      fields: {
        machineNo: '기계번호',
        machineName: '기계이름',
        category: '기계 구분',
        manufacturedDate: '생산일',
        installedDate: '설치일',
        manufacturer: '제조사',
        price: '가격',
        currency: '통화',
        polyMin: 'Poly 최소',
        polyMax: 'Poly 최대',
        nylonMin: 'Nylon 최소',
        nylonMax: 'Nylon 최대',
        cheeseRange: '치즈 수량(P/N)',
        yarnType: '전용여부',
        remark: '비고',
        isActive: '활성화'
      },
      yarnType: {
        poly: 'Poly 전용',
        nylon: 'Nylon 전용',
        common: '겸용'
      },
      active: '활성',
      inactive: '비활성',
      add: {
        title: '기계 등록',
        confirmMessage: '입력한 기계 정보를 등록하시겠습니까?',
        success: '기계가 등록되었습니다.'
      },
      edit: {
        title: '기계 수정',
        confirmMessage: '기계 정보를 수정하시겠습니까?',
        success: '기계 정보가 수정되었습니다.'
      },
      delete: {
        title: '기계 삭제',
        confirmMessage: '{{name}}을(를) 삭제하시겠습니까?'
      },
      validation: {
        price: '가격은 소수점 둘째 자리까지 숫자만 입력하세요.',
        polyMinMax: 'Poly 최대 수량은 최소 수량 이상이어야 합니다.',
        nylonMinMax: 'Nylon 최대 수량은 최소 수량 이상이어야 합니다.'
      },
      error: {
        duplicateMachineNo: '이미 존재하는 기계번호입니다.',
        invalidCurrency: '허용되지 않은 통화입니다.',
        invalidYarnType: '허용되지 않은 전용여부입니다.',
        minMax: '최대 수량은 최소 수량 이상이어야 합니다.'
      },
      searchPlaceholder: '기계번호/이름/제조사로 검색'
    },
    uom: {
      tabs: {
        registration: 'UOM 등록',
        conversion: 'UOM 환산 등록'
      },
      list: {
        title: 'UOM 목록'
      },
      form: {
        title: 'UOM 정보'
      },
      edit: {
        title: 'UOM 수정',
        confirmMessage: 'UOM을 수정하시겠습니까?',
        success: 'UOM이 수정되었습니다.'
      },
      fields: {
        code: '코드',
        name: '이름'
      },
      searchPlaceholder: '코드 또는 이름으로 검색',
      validation: {
        required: '필수 입력 항목입니다',
        duplicateUom: '이미 등록된 UOM 코드입니다'
      },
      add: {
        title: 'UOM 등록',
        confirmMessage: '새로운 UOM을 등록하시겠습니까?',
        success: 'UOM이 등록되었습니다.'
      },
      delete: {
        title: 'UOM 삭제',
        confirmMessage: '{{name}}을(를) 삭제하시겠습니까?'
      },
      conversion: {
        title: 'UOM 환산 등록',
        list: {
          title: 'UOM 환산 목록'
        },
        form: {
          title: 'UOM 환산 정보'
        },
        fields: {
          fromUom: '변환 대상 UOM',
          toUom: '변환 결과 UOM',
          factor: '환산 계수'
        },
        searchPlaceholder: 'UOM 코드, 이름 또는 환산 계수로 검색',
        validation: {
          required: '필수 입력 항목입니다',
          sameUom: '변환 대상과 변환 결과 UOM이 동일할 수 없습니다',
          duplicateConversion: '이미 등록된 환산 정보입니다',
          invalidFactor: '유효한 환산 계수를 입력해주세요'
        },
        add: {
          title: 'UOM 환산 등록',
          confirmMessage: '새로운 UOM 환산을 등록하시겠습니까?',
          success: 'UOM 환산이 등록되었습니다.'
        },
        delete: {
          title: 'UOM 환산 삭제',
          confirmMessage: '{{name}} 환산 정보를 삭제하시겠습니까?'
        }
      }
    },
    location: {
      list: {
        title: '창고 위치 목록'
      },
      form: {
        title: '창고 위치 정보'
      },
      edit: {
        title: '창고 위치 수정',
        confirmMessage: '창고 위치를 수정하시겠습니까?',
        success: '창고 위치가 수정되었습니다.'
      },
      fields: {
        siteCode: '사이트 코드',
        warehouse: '창고',
        binCode: '빈 코드',
        type: '타입',
        isActive: '활성화'
      },
      types: {
        warehouse: '창고',
        site: '사이트',
        bin: '빈'
      },
      searchPlaceholder: '사이트 코드, 창고, 빈 코드 또는 타입으로 검색',
      validation: {
        required: '필수 입력 항목입니다',
        duplicateLocation: '이미 등록된 창고 위치입니다'
      },
      add: {
        title: '창고 위치 등록',
        confirmMessage: '새로운 창고 위치를 등록하시겠습니까?',
        success: '창고 위치가 등록되었습니다.'
      },
      delete: {
        title: '창고 위치 삭제',
        confirmMessage: '{{name}}을(를) 삭제하시겠습니까?'
      },
      downloadLayout: '창고 배치도'
    },
    supplier: {
      list: {
        title: '공급자 목록'
      },
      form: {
        title: '공급자 정보'
      },
      edit: {
        title: '공급자 수정',
        confirmMessage: '공급자를 수정하시겠습니까?',
        success: '공급자가 수정되었습니다.'
      },
      fields: {
        partnerName: '공급자명',
        partnerGroup: '공급자 그룹',
        specification: '비고',
        bizRegNo: '사업자등록번호',
        postcode: '우편번호',
        address1: '주소1',
        address2: '주소2',
        region: '지역'
      },
      groups: {
        supplier: '공급자'
      },
      regions: {
        korea: '한국',
        indonesia: '인도네시아',
        china: '중국',
        usa: '미국',
        other: '기타'
      },
      searchPlaceholder: '공급자명, 비고, 사업자등록번호 또는 주소로 검색',
      validation: {
        required: '필수 입력 항목입니다',
        duplicateSupplier: '이미 등록된 공급자입니다'
      },
      add: {
        title: '공급자 등록',
        confirmMessage: '새로운 공급자를 등록하시겠습니까?',
        success: '공급자가 등록되었습니다.'
      },
      delete: {
        title: '공급자 삭제',
        confirmMessage: '{{name}}을(를) 삭제하시겠습니까?'
      }
    },
    itemTaxon: {
      title: '품목 분류',
      selectCategory: '카테고리 선택',
      noData: '표시할 데이터가 없습니다',
      hasAttributes: '속성 있음',
      attributes: '속성',
      levels: {
        category: '카테고리',
        type: '타입',
        spec: '스펙'
      }
    },
    item: {
      fields: {
        sku: 'SKU',
        name: '품목명',
        category: '카테고리',
        baseUom: '기본 단위',
        type: '타입',
        spec: '스펙',
        isDutyFree: '면세 여부',
        hsCode: 'HS 코드',
        attributes: '속성'
      },
      selectCategory: '카테고리 선택',
      name: '품목명',
      attributes: {
        keyPlaceholder: '키',
        valuePlaceholder: '값',
        add: '속성 추가'
      },
      list: {
        title: '품목 정보'
      },
      form: {
        title: '품목 등록'
      },
      add: {
        title: '품목 등록',
        confirmMessage: '새로운 품목을 등록하시겠습니까?',
        success: '품목이 등록되었습니다.'
      },
      edit: {
        title: '품목 수정',
        confirmMessage: '품목 정보를 수정하시겠습니까?',
        success: '품목 정보가 수정되었습니다.'
      },
      delete: {
        title: '품목 삭제',
        confirmMessage: '{{name}}을(를) 삭제하시겠습니까?'
      },
      validation: {
        required: '필수 항목을 입력해주세요.',
        duplicateItem: '이미 존재하는 품목입니다.',
        invalidJson: '올바른 JSON 형식이 아닙니다.'
      },
      searchPlaceholder: 'SKU, 품목명, 카테고리, 타입, 스펙, 단위, HS 코드로 검색'
    }
  }
  ,
  payment: {
    actions: {
      inputPayment: '결제 입력',
      printStatus: '인보이스 현황 프린트',
      excelDownload: '현황 EXCEL 다운로드'
    },
    messages: {
      selectCompanyFirst: '업체를 먼저 선택해주세요',
      selectItems: '업체를 선택해주세요'
    },
    excel: {
      vendor: '업체',
      month: '월별',
      arAmount: '미수금\n(Invoice)',
      augustInvoice: '08월 인보이스',
      invoiceAge: '인보이스 근수\n(건 수)',
      resultNote: '결재전달함',
      total: '총계'
    },
    fields: {
      searchConditions: '검색 조건'
    },
    companyDetail: {
      totalAr: '총 미수금액',
      totalReceived: '총 수금액',
      balance: '잔액',
      invoiceListTitle: '인보이스 목록',
      paymentListTitle: '결제 목록',
      columns: {
        invoiceNo: 'Invoice 번호',
        amount: '금액',
        receivedAmount: '수금액',
        balance: '잔액',
        dueDate: '만기일',
        status: '상태',
        paymentDate: '결제일',
        currency: '통화',
        paymentMethod: '결제방법',
        remark: '비고',
        createdBy: '등록자'
      }
    },
    print: {
      dialogTitle: '인보이스 현황',
      title: '인보이스 현황',
      dateOption: '날짜 선택',
      currentDate: '현재 날짜',
      searchDate: '검색 날짜',
      searchPlaceholder: '거래처명 검색',
      searching: '검색 중...',
      noSearchResults: '조회된 데이터가 없습니다',
      customDate: '사용자 지정 날짜',
      selectDate: '날짜 선택',
      dateDescription: '프린트할 인보이스 현황 날짜를 선택하세요',
      printDate: '프린트 날짜',
      companies: '개 업체',
      allCurrencies: '전체',
      yearSelect: '년도 선택',
      year: '년',
      selectedYear: '선택년도',
      currentYear: '현재 년도',
      selectDateDescription: '프린트할 인보이스 현황의 기준 날짜를 선택하세요',
      dateSelection: '날짜 선택 옵션',
      selectCustom: '사용자 지정 날짜 선택',
      selectedDate: '선택된 날짜',
      preview: '미리보기',
      generatedBy: 'SAMJIN ERP 시스템 생성',
      monthInvoice: '월 인보이스',
      qty: 'QTY',
      summary: '요약',
      currency: '통화',
      totalAmount: '총액',
      headers: {
        company: '상호',
        vendor: '거래처',
        vendorName: '거래처',
        monthly: '월별',
        month: '월별',
        monthSuffix: '월',
        invoice: '인보이스',
        invoiceNo: '인보이스 번호',
        qty: '수량',
        invoiceAmount: '청구 금액',
        arAmount: '청구 금액',
        amount: '금액',
        receivedAmount: '결제 금액',
        unpaid: '미수금',
        currentMonthInvoice: '{{month}}월 인보이스',
        currentMonthInvoiceQty: '인보이스 콘수(QTY)',
        remark: '비고',
        date: '일자',
        status: '상태',
        currency: '통화',
        invoiceCount: '인보이스 수',
        totalAmount: '총 금액',
        paidAmount: '결제 금액',
        unpaidAmount: '미수금',
        collectionRate: '수금률'
      },
      totalByCompany: '계',
      grandTotal: '총계',
      paidComplete: '결제완료',
      noDataAvailable: '조회된 데이터가 없습니다',
      noDataDescription: '선택하신 조건에 해당하는 인보이스 데이터가 존재하지 않습니다.',
      summaryTab: '통계',
      totalAmount: '총 금액',
      unpaidAmount: '미수금',
      collectionRate: '수금율',
      monthlyTrend: '미수금 월별 추이',
      currencyDistribution: '미수금 통화별 분포',
      monthlyUnpaid: '월별 미수금 현황',
      monthlyUnpaidDetail: '월별 미수금 업체별 상세',
      searchDisabledInSummary: '통계에서는 검색할 수 없습니다',
      invoiceStatusReport: '인보이스 현황 보고서',
      currencySection: '섹션',
      vendorNamePlaceholder: '거래처명',
      vendorSearch: '거래처 검색...',
      companyCount: '{{count}}개 업체',
      monthlyTotal: '월 총계',
      yearCurrencyStatus: '{{year}}년도 {{currency}} 현황',
      grandTotal: '전체 총계',
      summary: '요약',
      currencySummary: '통화별 요약',
      monthlyTrend: '월별 추이',
      monthSuffix: '월',
      totalUnpaid: '미수금 합계',
      paid: '완료',
      unpaid: '미수',
      reportDate: '보고서 생성일',
      executiveSummary: '경영진 요약',
      totalInvoices: '총 인보이스',
      totalAmountKRW: '총 금액 (KRW 환산)',
      avgCollectionRate: '평균 수금률',
      currencyBreakdown: '통화별 상세 분석',
      status: '상태',
      excellent: '우수',
      good: '양호',
      needImprovement: '개선 필요',
      monthlyPerformance: '월별 실적 차트',
      paidAmount: '결제 금액',
      trend: '추세',
      invoiceCount: '인보이스 수',
      yearSuffix: '년',
      currencyStatus: '현황',
      filter: {
        all: '전체',
        paid: '완료',
        unpaid: '미수'
      }
    },
    columns: {
      companyName: '업체명',
      arAmount: '미수금(Invoice)',
      qty: '인보이스 콘수(Qty)',
      oldestDate: '결제예정일'
    },
    paymentInput: {
      vendorInfoTitle: '업체 정보',
      vendorName: '업체명',
      unpaidAmount: '미수금(Invoice)',
      unpaidInvoiceTitle: '미납 인보이스 목록',
      inputSectionTitle: '결제 정보 입력',
      paymentListTitle: '결제 목록',
      submit: '입력 확인',
      columns: {
        select: '선택',
        actions: '작업'
      },
      fields: {
        date: '날짜',
        amount: '금액',
        paymentMethod: '입금방법',
        remark: '비고'
      },
      methodOptions: {
        bankTransfer: '계좌이체',
        cash: '현금',
        creditCard: '신용카드'
      },
      messages: {
        selectInvoices: '결제할 인보이스를 선택해주세요.',
        amountExceedsSelected: '입력한 금액({{amount}})이 선택된 인보이스들의 잔액 합계({{sum}})보다 큽니다.',
        deleteConfirm: '이 결제를 삭제하시겠습니까?',
        deleteSuccess: '결제가 삭제되었습니다.',
        deleteFailed: '결제 삭제에 실패했습니다.'
      }
    },
    accountsReceivable: {
      excel: {
        title: '{{year}}년 {{month}}월 인보이스 현황',
        currencyTransaction: '{{currency}}통장 거래',
        createdDate: '작성일: {{date}}',
        createdDateLabel: '작성일:',
        vendorName: '업체명',
        month: '월',
        accountsReceivable: '미수금',
        prevMonthInvoice: '{{month}}월 인보이스',
        amount: '금액',
        qty: '콘수',
        paymentStatus: '결제진행현황',
        remark: 'REMARK',
        monthFormat: '{{month}}월',
        yearMonthFormat: '{{year}}년 {{month}}월',
        subtotal: '합계',
        grandTotal: '총 합계',
        summaryTitle: '{{year}}년 {{month}}월 현황',
        summaryTitleWithDate: '{{year}}년 {{month}}월 {{day}}일 기준 현황',
        exchangeRate: '적용 환율:',
        exchangeRateLabel: '적용 환율',
        category: '구분',
        currency: '통화',
        originalAmount: '원본 금액',
        convertedUSD: '환율 적용 USD',
        convertedIDR: '환율 적용 IDR',
        convertedKRW: '환율 적용 KRW',
        prevMonthSales: '{{month}}월 매출',
        summarySheet: '요약',
        summary: '요약',
        filename: '{{year}}년 {{month}}월 현황',
        filenameWithDate: '{{year}}년 {{month}}월 {{day}}일 기준 현황'
      }
    }
  },

  windingDataPopup: {
    title: '배송 관리',
    basicInfo: '기본 정보',
    shippingInfo: '운송 정보',
    remarksAndNotes: '비고 및 메모',
    windingId: 'Winding ID',
    shippingTargetDate: '출하 예정일',
    truckName: '트럭명',
    numberOfBox: '박스 수량',
    timeOfDeparture: '출발 시간',
    timeOfArrival: '도착 시간',
    remarkForShipping: '출하 관련 비고',
    remark: '일반 비고',
    factory: '공장',
    loading: '데이터를 불러오는 중...',
    error: '오류 발생',
    retry: '다시 시도',
    close: '닫기',
    refresh: '새로고침',
    noData: '데이터 없음',
    networkError: '네트워크 오류가 발생했습니다. 인터넷 연결을 확인해주세요.',
    serverError: '서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
    notFound: 'Winding ID {{id}}에 해당하는 데이터를 찾을 수 없습니다.',
    timeoutError: '요청 시간이 초과되었습니다. 네트워크 상태를 확인해주세요.',
    fetchFailed: '데이터를 불러오는데 실패했습니다.',
    apiError: 'API 요청 중 오류가 발생했습니다. ({{status}})',
    unknownError: '알 수 없는 오류가 발생했습니다.',
    arrived: '도착',
    depart: '출발',
    completed: '완료',
    updating: '업데이트 중...',
    updateFailed: '업데이트에 실패했습니다.'
  },

  map: {
    controls: {
      title: '입고처 지도',
      searchPlaceholder: '공장명, 지역, 주소로 검색...',
      factories: '입고처 목록',
      selectedFactory: '선택된 입고처',
      region: '지역',
      address: '주소',
      shippingMark: '출하 마크',
      selected: '선택됨',
      noSearchResults: '검색 결과가 없습니다.',
      noFactories: '입고처가 없습니다.',
      zoomIn: '확대',
      zoomOut: '축소',
      resetView: '기본 보기'
    },
    geocoding: {
      progress: '주소 변환 중... {{current}}/{{total}}'
    },
    error: {
      fetchFailed: '입고처 데이터를 불러오는데 실패했습니다.',
      apiLoadFailed: '구글 지도 API를 불러오는데 실패했습니다.',
      apiKeyRequired: '구글 지도 API 키가 필요합니다. 환경 변수 REACT_APP_GOOGLE_MAPS_API_KEY를 설정해주세요.'
    }
  },
  inventory: {
    balance: {
      columns: {
        category: '카테고리',
        type: '타입',
        sku: 'SKU',
        name: '품목',
        location: '위치',
        qty: '수량',
        uom: '단위',
        note: '비고',
        report: '리포트'
      },
      report: {
        title: '재고 추이 리포트',
        graphButton: '그래프',
        period: '기간: {{start}} ~ {{end}}',
        itemIdLabel: '품목 ID: {{id}}',
        locationLabel: '위치: {{location}}',
        startDateLabel: '시작일',
        endDateLabel: '종료일',
        applyRange: '기간 적용',
        dailyChartTitle: '일별 수량 변화',
        cumulativeChartTitle: '일별 누적 수량',
        combinedChartTitle: '일별 수량 및 누적 추이',
        dailyChartLegend: '수량 증감',
        cumulativeChartLegend: '누적 수량',
        noData: '해당 기간에 데이터가 없습니다.',
        fetchError: '그래프 데이터를 불러오지 못했습니다.',
        invalidRange: '시작일이 종료일보다 늦을 수 없습니다.',
        locationRequired: '그래프를 보려면 위치 정보가 필요합니다.'
      }
    },
    adjustment: {
      title: '재고 이동',
      form: {
        title: '재고 이동 등록'
      },
      list: {
        title: '재고 이동 내역',
        createdAt: '생성 시간',
        txTime: '이동 시간',
        txType: '재고 이동 유형',
        txSubtype: '하위 유형',
        item: '품목',
        qty: '수량',
        uom: '단위',
        fromLocation: '출고 위치',
        toLocation: '입고 위치',
        inventoryStatus: '재고 상태',
        currency: '통화',
        note: '비고',
        searchPlaceholder: '품목, 유형, 비고 등으로 검색',
        selectItem: '품목을 선택하세요',
        searchHint: '품목을 반드시 선택해야 합니다. 검색 기간은 최대 1년입니다.',
        createdAtRange: '시스템 입력 시간',
        txTimeStart: '이동 시작 시간',
        txTimeEnd: '이동 종료 시간'
      },
      fields: {
        txTime: '재고 이동 시각',
        txType: '재고 이동 유형',
        docType: '문서 유형',
        docId: '문서 번호',
        item: '품목',
        lotId: 'LOT',
        fromLocation: '출고 위치',
        toLocation: '입고 위치',
        qty: '수량',
        uom: '단위',
        unitCost: '단가',
        currency: '통화',
        inventoryStatus: '재고 상태',
        note: '비고',
        noLocation: '미지정'
      },
      txTypes: {
        receipt: '입고',
        issue: '출고',
        transfer: '이동',
        adjustment: '조정',
        productionConsume: '생산 소비',
        productionOutput: '생산 산출'
      },
      txSubtypes: {
        normal: '정상',
        void: '취소',
        reversal: '역전'
      },
      inventoryStatus: {
        available: '사용 가능',
        reserved: '예약',
        wip: 'WIP',
        qcHold: 'QC 보류',
        damaged: '손상'
      },
      add: {
        title: '재고 이동 등록',
        confirmMessage: '새로운 재고 이동을 등록하시겠습니까?',
        success: '재고 이동이 등록되었습니다.'
      },
      edit: {
        title: '재고 이동 수정',
        confirmMessage: '재고 이동 정보를 수정하시겠습니까?',
        success: '재고 이동 정보가 수정되었습니다.'
      },
      validation: {
        required: '필수 항목을 입력해주세요.',
        invalidNumber: '올바른 숫자를 입력해주세요.',
        bothLocationsRequired: '출고 위치와 입고 위치 중 최소 하나는 입력해주세요.',
        itemRequired: '품목을 선택해주세요.',
        dateRange: '시작일은 종료일보다 이전이어야 합니다.',
        maxDateRange: '검색 기간은 365일을 초과할 수 없습니다.'
      },
      delete: {
        title: '재고 이동 Reversal 처리',
        confirmMessage: '재고 이동 내역을 Reversal 처리하시겠습니까?',
        success: 'reversal 처리가 완료 되었습니다.',
        receiptIssueWarning: '입출고 등록 페이지에서 삭제가 가능합니다.'
      }
    },
    batchInput: {
      saveConfirm: {
        title: '저장 확인',
        changedItems: '변경된 항목',
        txTimeField: '재고 이동 시각',
        txTimeLabel: '현재 재고 이동 시각: {{time}}',
        negativeValueError: '당일 입고 또는 당일 출고에 음수 값은 입력할 수 없습니다. 잘못 입력한 수량은 재고 변동 조회 페이지에서 revesal 처리를 하세요.'
      },
      title: '일괄 입력',
      snapshotPending: '마감 준비 중입니다.',
      date: '날짜',
      location: '위치',
      columns: {
        sku: 'SKU',
        name: '품목명',
        previousBalance: '전일재고',
        todayReceipt: '당일 입고',
        todayIssue: '당일 출고',
        todayBalance: '당일 재고',
        uom: '단위'
      },
      saveSuccess: '데이터가 저장되었습니다.',
      saveFailed: '데이터 저장에 실패했습니다.',
      noChanges: '변경사항 없음',
      noChangesMessage: '저장할 변경사항이 없습니다.',
      toggleUomTooltip: '기본 단위와 보조 단위 간 전환',
      baseUom: '기본 단위',
      secondaryUom: '보조 단위',
      selectDateAndCategory: '날짜와 카테고리를 선택해주세요.',
      bulkJob: {
        title: '재고 일괄 처리 진행 중',
        jobId: '작업 ID',
        status: '상태',
        pollingHint: '서버에서 비동기로 처리 중입니다. 완료될 때까지 잠시만 기다려 주세요.',
        lineIndex: '라인',
        error: '오류',
        timeout: '처리 대기 시간이 초과되었습니다. 재고 변동 조회에서 반영 여부를 확인해 주세요.',
        statusFailed: '작업 상태를 조회하지 못했습니다.',
        submitFailed: '일괄 작업을 제출하지 못했습니다.',
        noJobId: '서버 응답에 작업 ID가 없습니다. 관리자에게 문의해 주세요.',
        partialSuccess: '일부 라인에서 오류가 발생했습니다. (실패 {{count}}건) 목록을 확인해 주세요.',
        jobFailed: '일괄 작업이 실패했습니다.',
        chunkSummary: '청크: {{completed}} / {{total}} 완료',
        lineSummary: '라인: 성공 {{success}} · 실패 {{failure}} · 전체 {{total}}'
      }
    },
    lotBatch: {
      sharedBox: '같은 박스',
      tabs: {
        incoming: '입고 LOT 등록',
        outgoing: '출고 LOT 등록',
        batch: '출고 LOT 일괄 생성',
        batchComingSoon: '출고 일괄 등록 기능은 다음 단계에서 개발 예정입니다.'
      },
      vehicleAssignment: {
        title: '차량 배정',
        adjustButton: '차량 배정',
        workOrder: '출고 요청 목록',
        changeDate: '날짜 변경',
        batchChange: '일괄 날짜 변경',
        saveFailed: '저장 실패',
        saveFailedMessage: '차량 배정 저장 중 오류가 발생했습니다.',
        saveSuccess: '저장 완료',
        saveSuccessMessage: '차량 배정이 성공적으로 저장되었습니다.',
        truckList: 'TRUCK 목록',
        noTrucks: '등록된 트럭이 없습니다.',
        time: '시간',
        addDate: '날짜 추가',
        noLotForDate: '이 날짜에 배송할 LOT가 없습니다.',
        itemCount: '{{count}}개',
        dropToAssign: '여기에 드롭하여 차량 배정',
        dateTimeFormat: 'YYYY년 MM월 DD일 HH:mm',
        dateFormat: 'YYYY년 MM월 DD일',
        days: {
          sun: '일',
          mon: '월',
          tue: '화',
          wed: '수',
          thu: '목',
          fri: '금',
          sat: '토'
        }
      },
      giLot: {
        batch: {
          create: '출고 LOT 생성',
          edit: '출고 LOT 수정',
          update: '수정',
          editDescription: '선택된 {{count}}개의 출고 LOT을 수정합니다. 행을 드래그하여 순서를 변경할 수 있습니다.',
          createDescription: '선택된 {{count}}개의 출고 요청에 대해 출고 LOT을 생성합니다. 행을 드래그하여 순서를 변경할 수 있습니다.',
          labels: {
            requestId: '요청 ID',
            delivery: '배송지',
            customer: '고객사',
            manager: '담당자'
          },
          hasLotNo: '이미 LOT NO가 있는 항목이 선택되어 있습니다.',
          lotNoToggleOn: '전체',
          lotNoToggleOff: '미지정',
          lotNoToggleHint:
            '끄면 LOT NO가 없는 행만 표시하고, 켜면 LOT NO가 있는 행을 포함해 모두 표시합니다.',
          tableColumns: {
            reqId: '요청 ID',
            reqDate: '요청일',
            delivery: '배송지',
            customer: '고객사',
            manager: '담당자',
            qty: '수량',
            detail: '상세',
            box: '박스',
            lotNo: 'LOT NO',
            estTime: '예정 시각',
            slot: '슬롯',
            truck: '트럭',
            misc: '비고'
          },
          missingAttributes: {
            title: '속성 누락',
            message: '다음 아이템의 필수 속성이 누락되어 box와 중량을 계산할 수 없습니다:'
          },
          createSuccess: {
            title: '생성 완료',
            message: '출고 LOT가 성공적으로 생성되었습니다.'
          },
          createError: {
            title: '생성 오류',
            message: '일부 출고 LOT 생성에 실패했습니다:',
            general: '출고 LOT 생성 중 오류가 발생했습니다.'
          },
          updateSuccess: {
            title: '수정 완료',
            message: '출고 LOT가 성공적으로 수정되었습니다.'
          },
          updateError: {
            title: '수정 오류',
            message: '일부 출고 LOT 수정에 실패했습니다:',
            general: '출고 LOT 수정 중 오류가 발생했습니다.'
          },
          editError: {
            title: '조회 오류',
            message: '출고 LOT 데이터를 조회할 수 없습니다.',
            general: '출고 LOT 데이터 조회 중 오류가 발생했습니다.'
          },
          deleteConfirm: {
            title: '삭제 확인',
            message: '출고 LOT를 삭제하시겠습니까?'
          },
          deleteSuccess: {
            title: '삭제 완료',
            message: '출고 LOT가 성공적으로 삭제되었습니다.'
          },
          deleteError: {
            title: '삭제 오류',
            message: '출고 LOT ID를 찾을 수 없습니다.',
            general: '출고 LOT 삭제 중 오류가 발생했습니다.'
          }
        },
        fields: {
          lotNo: '로트 번호',
          expectedGiAt: '출고 예정 시점',
          workShift: '작업 마감 시간 슬롯',
          workShiftOptions: {
            none: '선택 안함',
            shift_00_03: '00:00 - 03:00',
            shift_03_06: '03:00 - 06:00',
            shift_06_09: '06:00 - 09:00',
            shift_09_12: '09:00 - 12:00',
            shift_12_15: '12:00 - 15:00',
            shift_15_18: '15:00 - 18:00',
            shift_18_21: '18:00 - 21:00',
            shift_21_24: '21:00 - 24:00'
          },
          docType: '문서 타입',
          docId: '문서 ID',
          deliveryId: '배송지 ID',
          deliveryName: '배송지명',
          addressSection: '배송지 정보',
          address1: '주소 1',
          address2: '주소 2',
          city: '도시',
          state: '주/도',
          postcode: '우편번호',
          country: '국가',
          lines: '출고 라인',
          detail: '상세',
          attributes: '속성',
          truck: '트럭'
        }
      },
      fields: {
        item: '품목',
        lotNo: 'LOT 번호',
        lotNoMode: 'LOT 번호 방식',
        supplierLotNo: '공급사 LOT 번호',
        mfgDate: '제조일자',
        expiryDate: '만료일자',
        qcStatus: 'QC 상태',
        lotNoPrefix: 'LOT 번호 접두사',
        category: '카테고리',
        attributes: '속성',
        createdAt: 'LOT 생성시간',
        truck: '트럭'
      },
      qcStatus: {
        available: '사용 가능',
        reserved: '예약',
        wip: 'WIP',
        qcHold: 'QC 보류',
        damaged: '손상'
      },
      list: {
        title: 'LOT 목록'
      },
      form: {
        title: 'LOT 등록',
        lotMode: {
          auto: '자동 생성',
          manual: '직접 입력'
        },
        lotNoAutoHint: '접두사를 입력하면 LOT 번호가 자동 생성됩니다.',
        lotNoManualHint: '이미 발급받은 LOT 번호를 입력하세요.'
      },
      add: {
        title: 'LOT 등록',
        confirmMessage: '새로운 LOT를 등록하시겠습니까?',
        success: 'LOT가 등록되었습니다.'
      },
      edit: {
        title: 'LOT 수정',
        confirmMessage: 'LOT 정보를 수정하시겠습니까?',
        success: 'LOT 정보가 수정되었습니다.'
      },
      validation: {
        required: '필수 항목을 입력해주세요.',
        itemRequired: '품목을 선택해주세요.',
        qcStatusRequired: 'QC 상태를 선택해주세요.',
        lotNoRequired: 'LOT 번호를 입력해주세요.'
      },
      searchPlaceholder: 'LOT 번호, 품목 ID, 공급사 LOT 번호로 검색...'
    },
    giLot: {
      fields: {
        lotNo: '로트 번호',
        expectedGiAt: '출고 예정 시점',
        workShift: '작업 마감 시간 슬롯',
        workShiftOptions: {
          none: '선택 안함',
          shift_00_03: '00:00 - 03:00',
          shift_03_06: '03:00 - 06:00',
          shift_06_09: '06:00 - 09:00',
          shift_09_12: '09:00 - 12:00',
          shift_12_15: '12:00 - 15:00',
          shift_15_18: '15:00 - 18:00',
          shift_18_21: '18:00 - 21:00',
          shift_21_24: '21:00 - 24:00'
        },
        docType: '문서 타입',
        docId: '문서 ID',
        deliveryId: '배송지 ID',
        deliveryName: '배송지명',
        addressSection: '배송지 정보',
        address1: '주소 1',
        address2: '주소 2',
        city: '도시',
        state: '주/도',
        postcode: '우편번호',
        country: '국가',
        lines: '출고 라인',
        detail: '상세',
        attributes: '속성',
        truck: '트럭'
      },
      lines: {
        lineLabel: '출고 라인 {{index}}',
        item: '아이템',
        itemId: '아이템 ID',
        qty: '수량',
        qtyBox: 'BOX 수량',
        mfgDate: '제조일',
        expiryDate: '만료일',
        qcStatus: 'QC 상태',
        subOrderId: '서브 오더 ID'
      },
      docType: {
        gir: '출고 요청',
        etc: 'ETC'
      },
      form: {
        title: '출고 LOT 등록'
      },
      add: {
        title: '출고 LOT 등록',
        confirmMessage: '출고 LOT를 등록하시겠습니까?',
        success: '출고 LOT가 등록되었습니다.'
      },
      edit: {
        title: '출고 LOT 수정',
        confirmMessage: '출고 LOT를 수정하시겠습니까?',
        success: '출고 LOT가 수정되었습니다.'
      },
      delete: {
        title: '삭제 확인',
        confirmMessage: '데이터를 삭제하시겠습니까?'
      },
      list: {
        title: '출고 LOT 목록'
      },
      validation: {
        linesRequired: '출고 라인의 아이템과 수량은 필수 입력 항목입니다.'
      },
      deliveryDialog: {
        title: '배송지 검색',
        searchPlaceholder: '배송지 ID, 배송지명, 주소로 검색...'
      },
      searchPlaceholder: '로트 번호, 문서 ID 등으로 검색...'
    },
    grLot: {
      fields: {
        supplier: '공급자',
        grDate: '입고 예정 일자',
        docType: '문서 타입',
        docId: '문서 ID',
        lines: '입고 라인',
        attributes: '속성'
      },
      lines: {
        lineLabel: '입고 라인 {{index}}',
        item: '아이템',
        uom: '단위',
        qty: '수량',
        qtyBox: 'BOX 수량',
        supplierLotNo: '공급자 로트 번호',
        mfgDate: '제조일',
        expiryDate: '만료일',
        qcStatus: 'QC 상태'
      },
      docType: {
        po: '발주서',
        etc: 'ETC'
      },
      validation: {
        linesRequired: '입고 라인의 아이템과 수량은 필수 입력 항목입니다.'
      }
    }
  },
  scm: {
    goodsReceipt: {
      list: {
        title: '입고 등록 내역',
        grDate: '입고 일자',
        supplier: '공급자',
        poId: '발주 번호',
        lines: '상세',
        note: '비고',
        createdAt: '생성 시간',
        searchPlaceholder: '입고 ID, 공급자, 발주 번호 등으로 검색'
      },
      form: {
        title: '입고 등록',
        lines: '상세',
        lineNo: '상세 {{no}}'
      },
      fields: {
        lotNo: 'LOT 번호',
        supplier: '공급자',
        grDate: '입고 일자',
        poId: '발주 번호',
        note: '비고',
        customDocDate: '세관 등록일',
        customDocType: '세관 문서 타입',
        customDocNo: '세관 문서 번호',
        customsSection: '세관 정보',
        item: '품목',
        lot: 'LOT',
        qty: '수량',
        uom: '단위',
        toLocation: '입고 위치',
        unitPrice: '단가',
        currency: '통화',
        totalAmount: '총금액'
      },
      add: {
        title: '입고 등록',
        confirmMessage: '새로운 입고를 등록하시겠습니까?',
        success: '입고가 등록되었습니다.'
      },
      edit: {
        title: '입고 수정',
        confirmMessage: '입고 정보를 수정하시겠습니까?',
        success: '입고 정보가 수정되었습니다.'
      },
      delete: {
        title: '입고 취소',
        confirmMessage: '입고를 취소하시겠습니까?'
      },
      validation: {
        required: '필수 항목을 입력해주세요.',
        atLeastOneLine: '최소 하나의 라인이 필요합니다.',
        lineRequired: '라인의 필수 항목을 입력해주세요.'
      },
      lotDialog: {
        title: '입고 LOT 선택',
        searchPlaceholder: 'LOT 번호, 품목 ID 등으로 검색...'
      }
    },
    goodsIssue: {
      list: {
        title: '출고 등록 내역',
        giTime: '출고 시각',
        toDelivery: '도착지',
        giPostNo: '출고 문서번호',
        outboundLotNo: '출고 LOT 번호',
        customsDocNo: '세관 문서 번호',
        lines: '상세',
        remarks: '비고',
        createdAt: '생성 시간',
        searchPlaceholder: '출고 ID, 도착지, 문서번호 등으로 검색'
      },
      form: {
        title: '출고 등록',
        lines: '상세',
        lineNo: '상세 {{no}}'
      },
      fields: {
        toDelivery: '도착지',
        giTime: '출고 시각',
        giPostNo: '출고 문서번호',
        outboundLotNo: '출고 LOT 번호',
        customsDocNo: '세관 문서 번호',
        customsReceiptNo: '세관 접수 번호',
        remarks: '비고',
        item: '품목',
        lot: 'LOT',
        qty: '수량',
        uom: '단위',
        fromLocation: '출고 위치',
        subOrderId: '서브 오더 ID',
        selectedFiles: '선택된 파일'
      },
      add: {
        title: '출고 등록',
        confirmMessage: '새로운 출고를 등록하시겠습니까?',
        success: '출고가 등록되었습니다.'
      },
      edit: {
        title: '출고 수정',
        confirmMessage: '출고 정보를 수정하시겠습니까?',
        success: '출고 정보가 수정되었습니다.'
      },
      delete: {
        title: '출고 취소',
        confirmMessage: '출고 등록 "{{name}}"을(를) 삭제하시겠습니까?'
      },
      validation: {
        required: '필수 항목을 입력해주세요.',
        atLeastOneLine: '최소 하나의 라인이 필요합니다.',
        lineRequired: '라인의 필수 항목을 입력해주세요.'
      },
      tabs: {
        general: '일반 출고 등록',
        batch: '출고 일괄 등록'
      },
      batch: {
        create: '출고 일괄 등록',
        edit: '출고 일괄 수정',
        createDialog: {
          title: '출고 일괄 등록'
        },
        editDialog: {
          title: '출고 일괄 수정'
        },
        submitting: '출고 등록 중...',
        deleteAll: '일괄 삭제',
        details: '상세',
        shipCustomsInfo: '출고 · 세관 정보',
        confirmDelete: '이 출고 등록을 삭제하시겠습니까?',
        confirmDeleteAll: '선택된 출고 등록을 모두 삭제하시겠습니까?',
        validation: {
          customsDocNoRequired: '세관 문서 번호는 필수 입력 항목입니다.',
          fieldRequired: '필수 입력 항목입니다.'
        },
        createError: '출고 등록 중 오류가 발생했습니다.',
        createFailed: 'LOT {{lotNo}}에 대한 출고 등록에 실패했습니다: {{errorMessage}}',
        truckColumn: 'TRUCK',
        completed: 'Completed',
        completedToggleOn: '전체',
        completedToggleOff: '대기',
        completedToggleHint:
          'Completed: 대기만 보면 GI POST ID가 없는 행만, 전체면 출고 완료 행을 포함합니다.',
        columns: {
          lotNo: 'LOT NO',
          estTime: '예정 시각',
          delivery: '배송지',
          truck: '트럭',
          detail: '상세',
          customDate: '세관 일자',
          customType: '세관 유형',
          customNo: '세관 번호',
          noExBC: 'No ExBC',
          giPostId: 'GI POST ID',
          giPostNo: 'GI POST NO',
          postAt: '등록 시각',
          updatedAt: '수정 시각'
        }
      },
      lotDetail: {
        title: '출고 LOT 상세',
        basicInfo: '기본 정보',
        lotLines: '출고 LOT Lines',
        shippingRequest: 'Shipping Request 정보',
        giRequest: 'GI Request 정보',
        orders: '주문 정보',
        consumption: '소비 정보',
        production: '생산 정보',
        giPost: '출고 등록 정보',
        fields: {
          lotNo: 'LOT NO',
          expectedGiAt: '예상 출고 시간',
          workShift: '작업 시간대',
          docType: '문서 타입',
          docId: '문서 ID',
          delivery: '배송지',
          address1: '주소 1',
          address2: '주소 2',
          cityState: '도시, 주/도',
          postcode: '우편번호',
          attributes: '속성',
          lineNo: 'Line No',
          itemId: 'Item ID',
          itemName: 'Item Name',
          qty: 'Qty',
          qtyBox: 'Qty Box',
          subOrderId: 'Sub Order ID',
          qcStatus: 'QC Status',
          mfgDate: 'Mfg Date',
          expiryDate: 'Expiry Date',
          giRequestId: 'GI Request ID',
          lines: 'Lines',
          orderId: 'Order ID',
          buyer: 'Buyer',
          vendor: 'Vendor',
          manager: 'Manager',
          deliveryField: 'Delivery',
          subOrders: 'Sub Orders',
          color: 'Color',
          price: 'Price',
          currency: 'Currency',
          uom: 'UOM',
          weight: 'Weight(kg)',
          location: 'Location',
          sourceTxName: 'Source TX Name',
          workType: 'Work Type',
          workId: 'Work ID',
          giPostId: 'GI Post ID',
          giPostNo: 'GI Post No',
          giLotNo: 'GI-LOT-NO',
          giTime: 'GI Time',
          customsReceiptNo: '접수번호',
          customDocType: 'Custom Doc Type',
          registrationNo: '등록번호',
          noDocExbc: 'No Doc ExBC',
          customDocDate: 'Custom Doc Date',
          remarks: 'Remarks',
          uomId: 'UOM ID',
          fromLocationId: 'From Location ID',
          lotId: 'Lot ID',
          unitPrice: 'Unit Price',
          grossWeight: 'Gross Weight'
        }
      }
    },
    deliveryInfo: {
      downloadAttachment: '첨부파일 다운로드',
      sections: {
        search: '1. 출고 조회',
        completion: '2. 배송 완료 정보 입력',
        completionEdit: '2. 배송 완료 정보 수정'
      },
      search: {
        hint: '세관 등록(접수) 번호 {{min}}자 이상 입력 후 검색하세요.',
        optionalHint:
          '선택 사항입니다. 출고를 조회해 자동 입력하거나, 아래에서 직접 입력할 수 있습니다. (검색 시 {{min}}자 이상)',
        placeholder: '세관 번호 일부 입력',
        minLength: '세관 번호는 {{min}}자 이상 입력해주세요.',
        noResults: '조회 결과가 없습니다.',
        failed: '출고 조회에 실패했습니다.',
        action: '작업',
        registered: '등록됨'
      },
      load: {
        failed: '출고 상세 조회에 실패했습니다.',
        noLines: '출고 라인 정보가 없습니다.'
      },
      fields: {
        customsRegistrationNo: '세관 등록 번호',
        deliveryStatus: '배송 상태',
        deliveryCompletedAt: '배송 완료 일자',
        suratJalanFiles: '출고증 스캔본'
      },
      giContext: {
        label: '불러온 출고 정보'
      },
      lines: {
        add: '라인 추가',
        itemPlaceholder: '품목 검색'
      },
      status: {
        pending: '대기',
        confirmed: '확인',
        rejected: '반려',
        cancelled: '취소'
      },
      files: {
        select: '파일 선택',
        hint: 'PDF 또는 이미지 파일을 업로드하세요.',
        existing: '등록된 출고증'
      },
      submit: {
        button: '배송 완료 등록',
        updateButton: '배송 완료 수정',
        submitting: '등록 중...',
        updating: '수정 중...',
        success: '배송 완료 정보가 등록되었습니다.',
        updateSuccess: '배송 완료 정보가 수정되었습니다.',
        failed: '배송 완료 등록에 실패했습니다.',
        noGiPost: '출고 데이터를 먼저 선택해주세요.',
        noLines: '유효한 라인(품목, 수량, 단위)을 1개 이상 입력해주세요.',
        noCustomsNo: '세관 등록 번호가 없습니다.',
        noCompletionDate: '배송 완료 일자를 선택해주세요.',
        filesRequired: '출고증 스캔본 파일을 1개 이상 첨부해주세요.'
      },
      email: {
        dialogTitle: '이메일 발송',
        dialogSubtitle: '담당자에게 이메일을 보내시겠습니까? 아래 내용을 확인한 뒤 보내기를 눌러주세요.',
        contentLanguage: '메일 문구 언어',
        lang: {
          ko: '한국어',
          en: 'English',
          id: 'Bahasa Indonesia'
        },
        defaultSubject: 'DELIVERY NOTE {{destination}} {{date}}',
        from: '발신',
        fromSystemFixed: '시스템 발송 주소 (서버 설정)',
        to: '수신',
        cc: '참조',
        subject: '제목',
        body: '본문',
        bodyHelper: '아래 내용이 메일 본문으로 발송됩니다. 필요 시 수정할 수 있습니다.',
        bodyIntro: '안녕하세요. 배송 완료 안내드립니다.',
        suratJalanNo: '출고증 번호',
        deliveryCompletedAt: '배송 완료일',
        deliveryDestination: '배송지(출고처)',
        linesHeader: '[품목별 수량]',
        styleNo: '스타일 번호',
        item: '품목',
        color: '컬러',
        qty: '수량',
        noReplyNotice: '※ 본 메일은 시스템에서 자동 발송되었으며 회신이 불가합니다. 문의사항은 담당자에게 연락해 주시기 바랍니다.',
        loadingOrderMeta: '오더 정보를 불러오는 중...',
        emailListHint: '쉼표, 세미콜론 또는 줄바꿈으로 여러 주소 입력',
        attachmentsTitle: '첨부 파일',
        attachmentsFixedHint: '배송 등록 시 첨부한 출고증 파일이 모두 첨부됩니다. (선택 변경 불가)',
        attachmentSizeLimit:
          '첨부 용량 제한: 합계 최대 {{total}}, 파일당 최대 {{perFile}}. 초과 시 발송되지 않습니다.',
        noAttachments: '첨부 파일이 없습니다.',
        sendButton: '이메일 보내기',
        sending: '이메일 발송 중...',
        sendSuccess: '이메일이 발송되었습니다.',
        sendFailed: '이메일 발송에 실패했습니다.',
        toRequired: '수신 이메일을 1개 이상 입력해주세요.',
        invalidEmails: '{{field}} 주소 형식이 올바르지 않습니다: {{emails}}',
        attachmentSizeExceeded: '첨부 파일 용량이 제한을 초과했습니다. 파일을 줄인 뒤 다시 시도해주세요.'
      },
      errors: {
        createFailed: '배송 완료 등록에 실패했습니다.',
        fetchFailed: '배송 완료 정보 조회에 실패했습니다.',
        updateFailed: '배송 완료 수정에 실패했습니다.'
      }
    },
    deliveryStatus: {
      filter: {
        title: '검색 조건'
      },
      columns: {
        deliveryStatus: '배송 상태',
        suratJalan: '출고증'
      },
      status: {
        notRegistered: '미등록'
      },
      table: {
        count: '{{count}} / {{total}}건',
        searchHint: '날짜 구간을 선택한 뒤 검색하세요.',
        endOfList: '마지막 데이터입니다.'
      },
      validation: {
        dateRequired: '시작일과 종료일을 입력해주세요.',
        dateRange: '시작일은 종료일보다 이전이어야 합니다.'
      },
      errors: {
        fetchFailed: '배송 현황 조회에 실패했습니다.'
      }
    }
  }
};